export default {
  en: {
    // Navigation Menu
    nav: {
      // Simplified sidebar (plain-language menu names)
      eInvoicing: 'e-Invoicing',
      reports: 'Reports',
      help: 'Help',
      supplierInvoices: 'Supplier Invoices',
      supplierCreditNotes: 'Supplier Credit Notes',
      supplierDebitNotes: 'Supplier Debit Notes',
      supplierRefundNotes: 'Supplier Refund Notes',
      selfBilled: 'Self-Billed',
      paymentsReceived: 'Payments Received',
      lhdnEInvoices: 'LHDN e-Invoices',
      peppolEInvoices: 'Peppol e-Invoices',
      supplierEInvoicesLhdn: 'Supplier e-Invoices (LHDN)',
      supplierEInvoicesPeppol: 'Supplier e-Invoices (Peppol)',
      supplierInvoicesToRespond: 'Supplier Invoices to Respond',
      lhdnSubmissionHistory: 'LHDN Submission History',
      peppolSubmissionHistory: 'Peppol Submission History',
      submissionHistory: 'Submission History',
      companySettings: 'Company Settings',
      imports: 'Imports',
      rptReconciliation: 'Reconciliation',
      rptEInvoiceStatus: 'e-Invoice Status',
      rptValidatedSales: 'Validated Sales',
      rptMonthlySales: 'Monthly Sales',
      rptValidatedPurchases: 'Validated Purchases',
      rptSupplierEInvoices: 'Supplier e-Invoices',
      rptEmailDelivery: 'Email Delivery',
      rptAllDocuments: 'All Documents',
      rptPeppolDelivery: 'Peppol Delivery Status',
      rptPeppolCompliance: 'Peppol Monthly Compliance',
      rptPeppolReconciliation: 'Peppol Reconciliation',
      sales: 'Sales',
      purchases: 'Purchases',
      eInvoiceExchange: 'e-Invoice Exchange',
      selfBilledDocs: 'Self-Billed Doc',
      expenseDoc: 'Expense Doc',
      lhdnEInvoice: 'LHDN e-Invoice',
      peppolEInvoice: 'Peppol e-Invoice',
      peppolSubmissions: 'Submissions',
      apInvoices: 'AP Invoices',
      sectionReports: 'Reports',
      sectionBusiness: 'Business',
      sectionAdmin: 'Administration',
      sectionHelp: 'Help',
      myPeppolSubmissions: 'Peppol Submissions',
      submissions: 'Submissions',
      lhdn: 'LHDN',
      peppol: 'Peppol',
      receivedDocumentsAp: 'Received Documents (AP)',
      dashboard: 'Dashboard',
      eInvoiceDashboard: 'E-Invoice Dashboard',
      reportingDashboard: 'Reporting Dashboard',
      peppolDashboard: 'Peppol Dashboard',
      peppolReporting: 'Peppol Reporting',
      peppolTransmissionStatusReport: 'Transmission Status Report',
      peppolMonthlyComplianceReport: 'Monthly Compliance Report',
      peppolReconciliationReport: 'Reconciliation Report',
      myPeppolDashboard: 'MY Peppol Dashboard',
      myPeppolReporting: 'MY Peppol Reporting',
      myPeppolTransmissionStatusReport: 'Transmission Status Report',
      myPeppolMonthlyComplianceReport: 'Monthly Compliance Report',
      myPeppolReconciliationReport: 'Reconciliation Report',
      reconciliationReport: 'Reconciliation Report',
      eDocumentByStatusReport: 'eDocument By Status Report',
      proofOfIncomeValidationReport: 'Proof of Income Validation Report',
      proofOfIncomeMonthlyReport: 'Proof of Income Monthly Report',
      proofOfExpensesValidationReport: 'Proof of Expenses Validation Report',
      emailLogsReport: 'Email Logs Report',
      advancedReporting: 'Advanced Reporting',
      apDocuments: 'AP Documents',
      documentLedger: 'Document Ledger',
      customers: 'Customers',
      customerGroups: 'Customer Groups',
      proFormaInvoices: 'Pro Forma Invoices',
      billingDocs: 'Billing Docs',
      invoices: 'Invoices',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      refundNotes: 'Refund Notes',
      consolidatedInvoices: 'Consolidated Invoices',
      expenseDocs: 'Expense Docs',
      selfBilledInvoices: 'Self Billed Invoices',
      selfBilledCreditNotes: 'Self Billed Credit Notes',
      selfBilledDebitNotes: 'Self Billed Debit Notes',
      selfBilledRefundNotes: 'Self Billed Refund Notes',
      eInvoices: 'E-Invoices',
      lhdnSubmissions: 'LHDN Submissions',
      sgPeppolSubmissions: 'SG Peppol Submissions',
      receivedOrders: 'Received Orders',
      receivedInvoices: 'Received Invoices',
      auditTrail: 'Audit Trail',
      orders: 'Orders',
      files: 'Files',
      payments: 'Payments',
      settings: 'Settings',
      setting: 'Setting',
      pdfTemplates: 'PDF Templates',
      roles: 'Roles',
      users: 'Users',
      faq: 'FAQ',
      aboutUs: 'About Us',
      privacyPolicy: 'Privacy Policy',
      termsAndConditions: 'Terms and Conditions',
      csvImportGuide: 'CSV Import Guide',
      smartPos: 'SmartPos',
    },

    // Page Titles
    pageTitle: {
      dashboard: 'Dashboard',
      display: 'Display',
      arautomationdashboard: 'AR AUTOMATION DASHBOARD',
      einvoicedashboard: 'E INVOICE DASHBOARD',
      emaillogsreportdashboard: 'Email Logs Report Dashboard',
      reconciliationreportdashboard: 'RECONCILIATION REPORT DASHBOARD',
      edocumentbystatusreportdashboard: 'eDOCUMENT BY STATUS REPORT DASHBOARD',
      proofofincomevalidationreportdashboard: 'PROOF OF INCOME VALIDATION REPORT DASHBOARD',
      proofofexpensesvalidationreportdashboard: 'PROOF OF EXPENSES VALIDATION REPORT DASHBOARD',
      proofofincomewaltzreportdashboard: 'PROOF OF INCOME MONTHLY REPORT DASHBOARD',
      proofofincomemonthlyreportdashboard: 'PROOF OF INCOME MONTHLY REPORT DASHBOARD',
      apdocumentsreport: 'AP DOCUMENTS REPORT',
      documentledgerreport: 'DOCUMENT LEDGER REPORT',
      csvimportguide: 'CSV IMPORT GUIDE',
      customers: 'Customers',
      importcustomers: 'Import Customers',
      customerdetail: 'Customer Detail',
      customersgroups: 'Customer Groups',
      newcustomersgroups: 'New Customer Groups',
      customergroupdetail: 'Customer Group Detail',
      emaillogs: 'Email Logs',
      displaylog: 'Display Log',
      files: 'Files',
      displayfile: 'Display File',
      invoices: 'Invoices',
      importinvoices: 'Import Invoices',
      displayinvoice: 'Display Invoice',
      proformainvoices: 'Pro Forma Invoices',
      importproformainvoices: 'Import Pro Forma Invoices',
      displayproformainvoice: 'Display Pro Forma Invoice',
      creditnotes: 'Credit Notes',
      importcreditnotes: 'Import Credit Notes',
      displaycreditnote: 'Display Credit Note',
      debitnotes: 'Debit Notes',
      importdebitnotes: 'Import Debit Notes',
      displaydebitnotes: 'Display Debit Notes',
      refundnotes: 'Refund Notes',
      importrefundnotes: 'Import Refund Notes',
      displayrefundnote: 'Display Refund Note',
      selfbilleddocuments: 'Self Billed Documents',
      selfbilledinvoices: 'Self Billed Invoices',
      selfbilledcreditnotes: 'Self Billed Credit Notes',
      selfbilleddebitnotes: 'Self Billed Debit Notes',
      selfbilledrefundnotes: 'Self Billed Refund Notes',
      importselfbilleddocuments: 'Import Self Billed Documents',
      displayselfbilleddocument: 'Display Self Billed Document',
      consolidatedinvoices: 'Consolidated Invoices',
      importconsolidatedinvoices: 'Import Consolidated Invoices',
      displayconsolidatedinvoice: 'Display Consolidated Invoice',
      einvoices: 'E-Invoices',
      displayeinvoice: 'Display E-Invoice',
      lhdnsubmissions: 'LHDN Submissions',
      displaylhdnsubmission: 'Display LHDN Submission',
      sgpeppolsubmissions: 'SG Peppol Submissions',
      displaysgpeppolsubmission: 'Display SG Peppol Submission',
      payments: 'Payments',
      newpayment: 'New Payment',
      displaypayment: 'Display Payment',
      setting: 'Setting',
      settingdetail: 'Setting Detail',
      pdftemplates: 'PDF Templates',
      roles: 'Roles',
      smartpos: 'SmartPos',
    },

    // Dashboard
    dashboard: {
      arAutomationDashboard: 'AR AUTOMATION DASHBOARD',
      welcomeMessage: 'Welcome to AR Automation Section of Smart Invoice Platform.',
      eInvoiceWelcome: 'Welcome to E-Invoicing Section of Smart Invoice Platform.',
      reportingWelcome: 'Welcome to Reporting Dashboard of Smart Invoice Platform.',
      arBalance: 'A/R BALANCE',
      openInvoices: 'OPEN INVOICES',
      overdueAmount: 'OVERDUE AMOUNT',
      documents: 'Documents',
      totalDocumentCounts: 'Total Document Counts',
      navigation: 'NAVIGATION',
      from: 'From:',
      to: 'To:',
      apply: 'Apply',
      applyReport: 'Apply',
      thisMonth: 'This Month',
      today: 'Today',
      fetchAllDates: 'Fetch All Dates',
      selectDateRange: 'SELECT DATE RANGE',
      selectCreatedDateRange: 'SELECT CREATED DATE RANGE',
      selectValidatedDateRange: 'SELECT VALIDATED DATE RANGE',
      collections: 'Collections',
      invoiced: 'Invoiced',
      collected: 'Collected',
      arAging: 'A/R Aging',
      topDebtors: 'Top Debtors',
      age: 'AGE',
      numInvoice: '# INVOICE',
      total: 'TOTAL',
      balance: 'BALANCE',
      daysOld: 'Days Old',
      results: 'Results',
      totalInbound: 'Total Inbound',
      totalOpen: 'Total Open',
      totalEinvoice: 'Total Einvoice',
      eDocumentsByStatus: 'EDocuments by Status',
      eDocumentsByType: 'EDocuments by Type',
      openPendingCreation: 'Open / pending creation by EDocument Types',
      byStatus: 'By Status',
      reconciliationReport: 'RECONCILIATION REPORT',
      exportCsv: 'Export CSV',
      eDocumentType: 'eDocument Type',
      inboundCount: 'Inbound Count',
      preCreation: 'Pre creation',
      readyToSubmit: 'Ready to submit',
      missingInfo: 'Missing Info',
      submitted: 'Submitted',
      valid: 'Valid',
      invalid: 'Invalid',
      rejected: 'Rejected',
      accepted: 'Accepted',
      error: 'Error',
      peppolWelcome: 'Welcome to the Peppol Dashboard of Smart Invoice Platform.',
      peppolReportingWelcome: 'Welcome to the Peppol Reporting of Smart Invoice Platform.',
      peppolMonthlyComplianceWelcome: 'Welcome to the Peppol Monthly Compliance Report of Smart Invoice Platform.',
      peppolReconciliationWelcome: 'Welcome to the Peppol Reconciliation Report of Smart Invoice Platform.',
      myPeppolWelcome: 'Welcome to the Malaysia Peppol Dashboard of Smart Invoice Platform.',
      myPeppolReportingWelcome: 'Welcome to the Malaysia Peppol PA Reporting of Smart Invoice Platform.',
      myPeppolMonthlyComplianceWelcome: 'Welcome to the Malaysia Peppol PA Monthly Compliance Report of Smart Invoice Platform.',
      myPeppolReconciliationWelcome: 'Welcome to the Malaysia Peppol PA Reconciliation Report of Smart Invoice Platform.',
      peppolByStatus: 'Peppol Submissions By Status',
      myPeppolByStatus: 'Malaysia Peppol Submissions By Status',
      peppolByDelivery: 'Delivery Status (Peppol / IRAS / Route)',
      totalSubmissions: 'Total Submissions',
      totalDocumentsTransmitted: 'Total Documents Transmitted',
      totalDocuments: 'Total Documents',
      successful: 'Successful',
      failed: 'Failed',
      inProgress: 'In Progress',
      errorsRejected: 'Errors / Rejected',
      notApplicable: 'N/A',
      channel: 'Channel',
      delivery: 'Delivery',
      peppolTransmissionStatusReportTitle: 'Peppol Transmission Status Report',
      peppolMonthlyComplianceReportTitle: 'Peppol Authority Monthly Compliance Report',
      peppolReconciliationReportTitle: 'Peppol Reconciliation Report',
      myPeppolTransmissionStatusReportTitle: 'Malaysia Peppol Transmission Status Report',
      myPeppolMonthlyComplianceReportTitle: 'Malaysia Peppol Authority Monthly Compliance Report',
      myPeppolReconciliationReportTitle: 'Malaysia Peppol Reconciliation Report',
      reportingPeriod: 'Reporting Period',
      fromMonthYear: 'From',
      toMonthYear: 'To',
      lastTwelveMonths: 'Last 12 Months',
      invalidPeriodRange: 'The "From" period must be on or before the "To" period.',
      month: 'Month',
      peppolTransmitted: 'Peppol Transmitted',
      successfulTransmissions: 'Successful Transmissions',
      irasAccepted: 'IRAS Accepted',
      rejectedFailed: 'Rejected / Failed',
      as4Acknowledged: 'AS4 Acknowledged',
      as4Errored: 'AS4 Errored',
      as4MessageId: 'AS4 Message ID',
      generatedAt: 'Generated At',
      downloadSubmissionCsv: 'Download Submissions CSV',
      downloadDocumentCsv: 'Download Documents CSV',
      routeC3C5: 'Peppol + IRAS (C3C5)',
      routeC5: 'IRAS Only (C5)',
      outcome: 'Outcome',
      transmitted: 'Transmitted',
      needsAttention: 'Submissions Needing Attention',
      noGapsFound: 'No gaps found. All submissions were transmitted successfully.',
      totalCount: 'Total Count',
      summaryByStatus: 'SUMMARY BY STATUS',
      transactionCount: 'Transaction Count',
      documentByStatusReport: 'DOCUMENT BY STATUS REPORT',
      noDataAvailable: 'No data available',
      filterByStatus: 'Filter by Status',
      all: 'All',
      eDocumentDate: 'eDocument Date',
      eDocumentNumber: 'e-Document Number',
      uniqueIdentifierNumber: 'Unique Identifier Number (UIN)',
      validationDate: 'Validation Date',
      buyerName: "Buyer's Name",
      sellerName: "Seller's Name",
      submissionDate: 'Submission Date',
      transactionReport: 'Transaction Report',
      sortedBasedOnCreatedDate: '- Sorted Based on the Created Date',
      sortedBasedOnValidatedDate: '- Sorted Based on the Validated Date',
      buyerId: "Buyer's ID",
      myrEquivalent: 'MYR Equivalent',
      invoiceAmount: 'Invoice Amount',
      crDrAdjusted: 'CR/DR Adjusted',
      lhdnValidationDate: 'LHDN Validation Date',
      no: 'No',
      previous: 'Previous',
      next: 'Next',
      page: 'Page',
      rows: 'rows',
      reportBasedOnValidationDate: 'Report Based on Validation Date',
      reportBasedOnCreationDate: 'Report Based on Creation Date',
      monthAndYear: 'Month and Year',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      totalEmails: 'Total Emails',
      success: 'Success',
      failure: 'Failure',
      resendEmail: 'Resend Email',
      srNo: 'Sr.No.',
      documentNumber: 'Document Number',
      recipientEmail: 'Recipient Email',
      failedAt: 'Failed At',
      resend: 'Resend',
      invoice: 'invoice',
      proForma: 'pro-forma',
      creditNote: 'credit note',
      debitNote: 'debit note',
      refundNote: 'refund note',
      consolidated: 'consolidated',
      consolidatedInvoice: 'consolidated invoice',
      selfBilledInvoice: 'self-billed invoice',
      selfBilledCreditNote: 'self-billed credit note',
      selfBilledDebitNote: 'self-billed debit note',
      selfBilledRefundNote: 'self-billed refund note',
      open: 'open',
      processing: 'processing',
      paid: 'paid',
      close: 'close',
      cancelled: 'cancelled',
      name: 'NAME',
      numberOfCustomer: 'NUMBER OF CUSTOMER',
      action: 'ACTION',
      newCustomerGroup: 'New Customer Group',
      customer: 'CUSTOMER',
      allDocuments: 'All Documents',
      receivables: 'Receivables (AR)',
      payables: 'Payables (AP)',
      totalReceivables: 'Total Receivables (AR)',
      totalPayables: 'Total Payables (AP)',
      netPosition: 'Net Position',
      netReceivable: 'Net Receivable',
      netPayable: 'Net Payable',
      documents: 'Documents',
      selectIssuedDateRange: 'SELECT ISSUED DATE RANGE',
      filterOptions: 'FILTER OPTIONS',
      category: 'Category',
      allCategories: 'All Categories',
      arRegular: 'AR Regular',
      arSelfBilled: 'AR Self Billed',
      apReceived: 'AP Received',
      status: 'Status',
      allStatuses: 'All Statuses',
      documentType: 'Document Type',
      allTypes: 'All Types',
      counterparty: 'Counterparty',
      searchCounterparty: 'Search counterparty...',
      currency: 'Currency',
      allCurrencies: 'All Currencies',
      unpaidOnly: 'Unpaid Only (AR)',
      overdueOnly: 'Overdue Only (AR)',
      hasEInvoice: 'Has E-Invoice',
      clearFilters: 'Clear Filters',
      documentCount: 'Document Count',
      totalAmount: 'Total Amount',
      documentLedgerReport: 'Document Ledger Report',
      exportExcel: 'Export Excel',
      exportPdf: 'Export PDF',
      no: 'No',
      direction: 'Direction',
      documentNo: 'Document No',
      type: 'Type',
      counterpartyTin: 'Counterparty TIN',
      issuedDate: 'Issued Date',
      dueReceivedDate: 'Due/Received Date',
      exclTax: 'Excl. Tax',
      tax: 'Tax',
      eInvoiceStatus: 'E-Invoice Status',
      lhdnUuid: 'LHDN UUID',
      accumulatingTotal: 'Accumulating Total',
      thisYear: 'This Year',
      showing: 'Showing',
      to: 'To:',
      of: 'of',
      entries: 'entries',
      rowsPerPage: 'Rows per page',
      documentLedger: 'Document Ledger - Unified view of all AR (Receivables) and AP (Payables) documents',
      recordPerPage: 'Record Per Page',
      bulkImport: 'Bulk Import',
      submitForValidation: 'Submit For Validation',
      consolidateInvoices: 'Consolidate Invoice(s)',
      exportCsvReport: 'Export CSV Report',
      exportSelected: 'Export Selected',
      docNo: 'Doc No',
      dueAt: 'Due At',
      date: 'Date',
      selectPdfTemplate: 'SELECT PDF TEMPLATE',
      general: 'General',
      documentTypeRequired: 'Document Type *',
      printType: 'Print Type',
      customiseTemplate: 'Customise Template',
      pageMargin: 'Page Margin',
      leftMargin: 'Left Margin *',
      topMargin: 'Top Margin *',
      rightMargin: 'Right Margin *',
      bottomMargin: 'Bottom Margin *',
      filter: 'Filter',
      customerId: 'CUSTOMER ID',
      customerName: 'CUSTOMER NAME',
      parentCustomer: 'PARENT CUSTOMER',
      email: 'EMAIL',
      phone: 'PHONE',
      reference1: 'REFERENCE 1',
      reference2: 'REFERENCE 2',
      reference3: 'REFERENCE 3',
      dueDateFrom: 'DUE DATE FROM',
      dueDateTo: 'DUE DATE TO',
      creationDateFrom: 'CREATION DATE FROM',
      creationDateTo: 'CREATION DATE TO',
      updateDateFrom: 'UPDATE DATE FROM',
      updateDateTo: 'UPDATE DATE TO',
      showPendingEInvoice: 'SHOW PENDING E-INVOICE CREATION ONLY',
      amount: 'AMOUNT',
      amountFrom: 'AMOUNT FROM',
      amountTo: 'AMOUNT TO',
      transactionType: 'TRANSACTION TYPE',
      paymentChannel: 'PAYMENT CHANNEL',
      submissionDateFrom: 'SUBMISSION DATE FROM',
      submissionDateTo: 'SUBMISSION DATE TO',
      lhdnStatus: 'LHDN STATUS',
      submissionId: 'SUBMISSION ID',
      uuid: 'UUID',
      buyerTin: 'BUYER TIN',
      buyerName: 'BUYER NAME',
      supplierTin: 'SUPPLIER TIN',
      supplierName: 'SUPPLIER NAME',
      fileName: 'FILE NAME',
      fileType: 'FILE TYPE',
      uploadDateFrom: 'UPLOAD DATE FROM',
      uploadDateTo: 'UPLOAD DATE TO',
      invoiceNo: 'INVOICE NO',
      id: 'ID',
      type: 'TYPE',
      types: 'TYPES',
      transactionId: 'TRANSACTION ID',
      dateFrom: 'DATE FROM',
      dateTo: 'DATE TO',
      exported: 'EXPORTED',
      eInvoiceId: 'E-Invoice ID',
      sgPeppolStatus: 'SG Peppol Status',
      sgUen: 'SG UEN (InvoiceNow)',
      sgUenPlaceholder: 'e.g. 202200001A',
      irasStatus: 'IRAS Status',
      destination: 'Destination',
      acknowledgementId: 'Acknowledgement ID',
      buyerResponse: 'Buyer Response',
      sent: 'Sent',
      completed: 'Completed',
      customerSupplier: 'Customer / Supplier',
      createdAt: 'Created At',
      submittedAt: 'Submitted At',
      updatedAt: 'Updated At',
      submitToLhdn: 'Submit to LHDN',
      bulkPdfDownload: 'Bulk PDF Download',
      refreshPage: 'Refresh',
      submitToSgPeppol: 'Submit',
      viewDetails: 'View Details',
      download: 'Download',
      cancel: 'Cancel',
      void: 'Void',
      na: 'N/A',
      applyInvoice: 'Apply Invoice',
      supplier: 'Supplier',
      bulkDelete: 'Bulk Delete',
      appliedToInvoice: 'Applied to Invoice',
      description: 'Description',
      internalId: 'Internal ID',
      transactionId: 'Transaction ID',
      export: 'Export',
      refresh: 'Refresh',
      completedAt: 'Completed At',
      emailFrom: 'Email From',
      emailTo: 'Email To',
      usersRoleManagement: 'Users Role Management',
      searchUsers: 'Search users by name or email...',
      addNewUser: 'Add New User',
      userName: 'User Name',
      role: 'Role',
      actions: 'Actions',
      setUserInactive: 'Set user to inactive',
      sgPeppolSubmissions: 'SG Peppol Submissions',
      docs: 'Docs',
      route: 'Route',
      peppol: 'Peppol',
      iras: 'IRAS',
      basic: 'Basic',
      groupName: 'Group Name',
      customers: 'Customers',
      downloadEInvoice: 'DOWNLOAD E-INVOICE',
      downloading: 'DOWNLOADING...',
      viewPayload: 'View Payload',
      overview: 'Overview',
      invoiceNo: 'Invoice No',
      irbmNo: 'IRBM No',
      eInvoiceType: 'E-invoice Type',
      eInvoiceVersion: 'E-invoice Version',
      exchangeRate: 'Exchange Rate',
      exportInvoices: 'EXPORT INVOICES',
      registrationTypeNo: 'Registration Type / No',
      save: 'Save',
      close: 'Close',
      back: 'Back',
      searchByTransactionId: 'Search by Transaction ID',
      selectStatus: 'Select status',
      selectRoute: 'Select route',
      selectDocumentType: 'Select document type',
      paymentChannelSetting: 'Payment Channel Setting',
      newPaymentChannel: 'New Payment Channel',
      provider: 'Provider',
      customerGroup: 'Customer Group',
      emailSmtpSetting: 'Email SMTP Setting',
      newSmtpSetting: 'New SMTP Setting',
      host: 'Host',
      port: 'Port',
      user: 'User',
      tenantInfo: 'Tenant Info',
      updateTenantInfo: 'Update Tenant Info',
      tin: 'TIN',
      registrationNo: 'Registration No',
      sst: 'SST',
      contactNo: 'Contact No',
      mailingAutomationSetting: 'Mailing Automation Setting',
      updateMailingAutomation: 'Update Mailing Automation',
      sendEmailUponCreation: 'Send Email Upon Creation',
      sendEmailUponValidated: 'Send Email Upon Validated',
      sendEmailUponAdhocImported: 'Send Email Upon Adhoc Imported',
      sendEmailUponAdhocValidated: 'Send Email Upon Adhoc Validated',
      enabledCustomerGroup: 'Enabled Customer Group',
      enabledDocumentType: 'Enabled Document Type',
      enabled: 'Enabled',
      disabled: 'Disabled',
      einvoiceAutomationSetting: 'EInvoice Automation Setting',
      updateEinvoiceAutomation: 'Update EInvoice Automation',
      createEinvoiceUponImported: 'Create EInvoice Upon Imported',
      submitEinvoiceUponValidated: 'Submit EInvoice Upon Validated',
      otpSetting: 'OTP Setting',
      updateOtpSetting: 'Update OTP Setting',
      isTenantOtpEnabled: 'Is Tenant OTP Enabled',
      isPayeeOtpEnabled: 'Is Payee OTP Enabled',
      sgPeppolSetting: 'SG Peppol (InvoiceNow) Setting',
      configureSgPeppol: 'Configure SG Peppol',
      singaporeUen: 'Singapore UEN',
      peppolId: 'Peppol ID',
      gstRegistrationNo: 'GST Registration No',
      irasC5UserId: 'IRAS C5 User ID',
      verificationStatus: 'Verification Status',
      active: 'Active',
      inactive: 'Inactive',
      verified: 'Verified',
      pending: 'Pending',
      logoImage: 'Logo Image',
      letterHeadImage: 'Letter Head Image',
      footerImage: 'Footer Image',
      update: 'Update',
      pdfTemplates: 'Pdf Templates',
      addTemplate: 'Add Template',
      templateName: 'Template Name',
      customised: 'Customised',
      uploadFile: 'Upload File',
      importErrors: 'Import Errors',
      previewData: 'Preview Data',
      clearFile: 'Clear File',
      download: 'Download',
      downloadCreditNote: 'DOWNLOAD CREDIT NOTE',
      downloadDebitNote: 'DOWNLOAD DEBIT NOTE',
      downloadInvoice: 'DOWNLOAD INVOICE',
      unitCost: 'Unit Cost',
      appliedAmount: 'Applied Amount',
      appliedAt: 'Applied At',
      appliedTo: 'Applied To',
      lhdnUuid: 'LHDN UUID',
      searchTin: 'Search Tin',
      sstNumber: 'SST Number',
      emailForLhdn: 'Email Address for LHDN',
      contactEmailAddress: 'Contact Email Address',
      paymentTerm: 'Payment Term',
      paymentTermType: 'Payment Term Type',
      netPaymentTermDay: 'Net Payment Term Day',
      address: 'Address',
      addressNum: 'Address Num',
      address1: 'Address 1',
      address2: 'Address 2',
      postalCode: 'Postal Code',
      city: 'City',
      state: 'State',
      country: 'Country',
      others: 'Others',
      draftEmail: 'Draft Email',
      draftMessage: 'Draft Message',
      sendToPeppol: 'Send to Peppol',
      peppolData: 'Peppol Data',
      senderId: 'Sender Id',
      receiverId: 'Receiver Id',
      codeNumber: 'Code Number',
      customerTin: 'Customer Tin',
      userInformation: 'User Information',
      companyRegistrationNo: 'Company Registration No',
      tourismRegistrationNo: 'Tourism Registration No',
      msicCode: 'MSIC Code',
      businessActivityDescription: 'Business Activity Description',
      activateIdleTimeOut: 'Activate Idle Time Out',
      maxUserCount: 'Maximum allowed user count',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      addressPostal: 'Address Postal',
      addressCity: 'Address City',
      supportEmailAddress: 'Support Email Address',
      digitalSignature: 'Digital Signature',
      supplierBankNumber: 'Supplier Bank Number',
      fractionDigits: 'Fraction Digits',
      businessStationery: 'Business Stationery',
      letterHead: 'Letter Head',
      footer: 'Footer',
      note: 'Note',
      submit: 'Submit',
      roleManagement: 'Role Management',
      searchRoles: 'Search roles...',
      roleName: 'Role Name',
      permissions: 'Permissions',
      userType: 'User Type',
      password: 'Password',
      emailSmtp: 'Email SMTP',
      setCustomerAccess: 'Set Customer Access',
      customTemplate: 'Custom Template',
      standardTemplates: 'Standard Template(s)',
      header: 'header',
      body: 'body',
      notActivated: 'Not Activated',
      sgPeppolConfiguration: 'Singapore Peppol (InvoiceNow) Configuration',
      accountInfo: 'Account Info',
      whatsappMessage: 'Whatsapp Message',
      paidAt: 'Paid At',
      dueDate: 'Due Date',
      invoiceDiscount: 'Invoice Discount',
      totalDiscount: 'Total Discount',
      totalTax: 'Total Tax',
      balance: 'Balance',
      remarks: 'Remarks',
      invoiceItems: 'Invoice Items',
      eInvoiceSubmittedDate: 'E-invoice Submitted Date',
      eInvoiceValidationUrl: 'E-invoice Validation URL',
      eInvoiceValidatedDate: 'E-invoice Validated Date',
      expandSupplierDetails: 'Expand Supplier Details',
      hideSupplierDetails: 'Hide Supplier Details',
      expandBuyerDetails: 'Expand Buyer Details',
      hideBuyerDetails: 'Hide Buyer Details',
      expandRecipientDetails: 'Expand Recipient Details',
      hideRecipientDetails: 'Hide Recipient Details',
      expandTaxDetails: 'Expand Tax Details',
      hideTaxDetails: 'Hide Tax Details',
      expandCustomFormDetails: 'Expand Custom Form Details',
      hideCustomFormDetails: 'Hide Custom Form Details',
      showTaxDetails: 'Show tax details',
      hideTaxDetailsTooltip: 'Hide tax details',
      supplier: 'Supplier',
      buyer: 'Buyer',
      recipient: 'Recipient',
      editItem: 'Edit Item',
      edit: 'Edit',
      supplierName: 'Supplier Name *',
      supplierTin: 'Supplier TIN *',
      supplierTourismRegistration: 'Supplier Tourism Registration',
      supplierMsicCode: 'Supplier Malaysia Standard Industrial Classification (MSIC) Code *',
      supplierBusinessActivity: 'Supplier Business Activity Description *',
      supplierEmail: 'Supplier Email',
      supplierAddressNum: 'Supplier Address Num *',
      supplierAddressLine1: 'Supplier Address Line 1',
      supplierAddressLine2: 'Supplier Address Line 2',
      supplierAddressPostal: 'Supplier Address Postal *',
      supplierAddressCity: 'Supplier Address City *',
      supplierContactNumber: 'Supplier Contact Number *',
      supplierState: 'Supplier State *',
      supplierCountry: 'Supplier Country *',
      supplierSst: 'Supplier SST',
      buyerName: 'Buyer Name *',
      buyerTin: 'Buyer TIN *',
      buyerEmail: 'Buyer Email',
      buyerAddressNum: 'Buyer Address Num *',
      buyerAddressLine1: 'Buyer Address Line 1',
      buyerAddressLine2: 'Buyer Address Line 2',
      buyerAddressPostal: 'Buyer Address Postal *',
      buyerAddressCity: 'Buyer Address City *',
      buyerContactNumber: 'Buyer Contact Number *',
      buyerAddressState: 'Buyer Address State *',
      buyerCountry: 'Buyer Country *',
      buyerSst: 'Buyer SST',
      recipientName: 'Recipient Name',
      recipientTin: 'Recipient TIN',
      recipientRegistration: 'Recipient Registration',
      recipientAddressNum: 'Recipient Address Num',
      recipientAddressLine1: 'Recipient Address Line 1',
      recipientAddressLine2: 'Recipient Address Line 2',
      recipientAddressPostal: 'Recipient Address Postal',
      recipientAddressCity: 'Recipient Address City',
      recipientAddressState: 'Recipient Address State',
      recipientAddressCountry: 'Recipient Address Country',
      taxInfo: 'Tax Info',
      taxExemptionReason: 'Tax Exemption Reason',
      totalTaxAmountPerTaxType: 'Total Tax Amount Per Tax Type',
      totalTaxableAmountPerTaxType: 'Total Taxable Amount Per Tax Type',
      totalExemptionAmount: 'Total Exemption Amount',
      customsFormDetails: 'Customs Form Details',
      customForm: 'Custom Form',
      customsReferenceNum: 'Customs Reference Num',
      customsReferenceNum2: 'Customs Reference Num 2',
      incoterms: 'Incoterms',
      irbmInfo: 'IRBM Info',
      missingItems: 'Missing Item(s)',
      submissionErrors: 'Submission Error(s)',
      cancellationResponse: 'Cancellation Response',
      cancellationReason: 'Cancellation Reason',
      editLineItem: 'EDIT LINE ITEM',
      classification: 'Classification',
      uom: 'UOM',
      taxExemptionAmount: 'Tax Exemption Amount',
      taxBreakdown: 'Tax Breakdown',
      taxTypeHeader: 'Tax Type',
      taxRate: 'Tax Rate %',
      discountRate: 'Discount Rate',
      lineTotal: 'Line Total',
      taxCategory: 'Tax Category',
      unit: 'Unit',
      id: 'ID',
      taxableAmount: 'Taxable Amount',
      taxAmount: 'Tax Amount',
      reason: 'Reason',
      invoiceLineItems: 'Invoice Line Items',
      downloadPayload: 'DOWNLOAD PAYLOAD',
      searchTin: 'Search Tin',
      bulkImport: 'Bulk Import',
      bulkApply: 'Bulk Apply',
      bulkImportCustomers: 'Bulk import your customers into Smart Invoice Platform.',
      bulkImportConsolidatedInvoices: 'Bulk import your consolidated invoices into Smart Invoice Platform.',
      bulkImportProForma: 'Bulk import your Pro-Forma invoices into Smart Invoice Platform.',
      bulkImportSelfBilled: 'Bulk import your self-billed invoices into Smart Invoice Platform.',
      bulkImportDebitNote: 'Bulk import your Debit Note into Smart Invoice Platform.',
      bulkImportRefundNotes: 'Bulk import your Refund Notes into Smart Invoice Platform.',
      bulkImportCreditNotes: 'Bulk import your Credit Notes into Smart Invoice Platform.',
      bulkImportCustomersToGroup: 'Bulk import your customers into this Customer Group.',
      customer: 'Customer',
      overview: 'Overview',
      paymentFrom: 'Payment From',
      applyPaymentTo: 'Apply Payment To',
      uploadAttachments: 'Upload Attachments',
      chequeInfo: 'Cheque Info',
      onlinePaymentInfo: 'Online Payment Info',
      paymentChannel: 'Payment Channel',
      setCustomerAccess: 'Set Customer Access',
      basic: 'Basic',
      items: 'Items',
      itemsCount: 'Item(s)',
      item: 'Item',
      quantity: 'Quantity',
      tax: 'Tax',
      discount: 'Discount',
      subtotal: 'Subtotal',
      payments: 'Payments',
      proForma: 'Pro Forma',
      creditNotes: 'Credit Notes',
      debitNotes: 'Debit Notes',
      refundNotes: 'Refund Notes',
      attachments: 'Attachments',
      file: 'File',
      phone: 'Phone',
      emailAddress: 'Email Address',
      appliedToInvoice: 'Applied To Invoice',
      standard: 'Standard',
      reference1: 'Reference 1',
      reference2: 'Reference 2',
      reference3: 'Reference 3',
      verify: 'Verify',
      currencyCode: 'Currency Code',
      registrationType: 'Registration Type',
      updateTenantInfo: 'UPDATE TENANT INFO',
      minFractionDigitsPrice: 'Minimum Fraction Digits Price',
      maxFractionDigitsPrice: 'Maximum Fraction Digits Price',
      minFractionDigitsQuantity: 'Minimum Fraction Digits Quantity',
      maxFractionDigitsQuantity: 'Maximum Fraction Digits Quantity',
      minFractionDigitsAmount: 'Minimum Fraction Digits Amount',
      maxFractionDigitsAmount: 'Maximum Fraction Digits Amount',
      userDefinedDateFormat: 'User Defined Date Format',
      rightMargin: 'Right Margin',
      bottomMargin: 'Bottom Margin',
      select: 'SELECT',
      preview: 'Preview',
      upload: 'Upload',
      processing: 'Processing...',
      currency: 'Currency',
      amount: 'Amount',
      bulkImportInvoices: 'Bulk import your invoices into Smart Invoice Platform.',
    },

    // Common Actions
    actions: {
      add: 'Add',
      addNew: 'Add New',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      clear: 'Clear',
      import: 'Import',
      download: 'Download',
      upload: 'Upload',
      view: 'View',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      reset: 'Reset',
      clear: 'Clear',
      select: 'Select',
      selectAll: 'Select All',
      copy: 'Copy',
      print: 'Print',
      refresh: 'Refresh',
      update: 'Update',
      create: 'Create',
      send: 'Send',
      resend: 'Resend',
      approve: 'Approve',
      reject: 'Reject',
      continue: 'Continue',
    },

    // Common Labels
    labels: {
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      date: 'Date',
      time: 'Time',
      status: 'Status',
      type: 'Type',
      description: 'Description',
      amount: 'Amount',
      total: 'Total',
      subtotal: 'Subtotal',
      tax: 'Tax',
      discount: 'Discount',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      unitCost: 'Unit Cost',
      price: 'Price',
      item: 'Item',
      items: 'Items',
      customer: 'Customer',
      supplier: 'Supplier',
      invoice: 'Invoice',
      invoiceNo: 'Invoice No',
      invoiceNumber: 'Invoice Number',
      documentNo: 'Document No',
      reference: 'Reference',
      notes: 'Notes',
      remarks: 'Remarks',
      currency: 'Currency',
      paymentMethod: 'Payment Method',
      paymentStatus: 'Payment Status',
      dueDate: 'Due Date',
      issueDate: 'Issue Date',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      createdBy: 'Created By',
      overview: 'Overview',
      details: 'Details',
      summary: 'Summary',
      history: 'History',
      all: 'All',
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      draft: 'Draft',
      sent: 'Sent',
      paid: 'Paid',
      unpaid: 'Unpaid',
      overdue: 'Overdue',
      cancelled: 'Cancelled',
      completed: 'Completed',
      processing: 'Processing',
      failed: 'Failed',
      success: 'Success',
    },

    // Authentication
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      newPassword: 'New Password',
      currentPassword: 'Current Password',
      forgotPassword: 'Forgot Password?',
      resetPassword: 'Reset Password',
      rememberMe: 'Remember Me',
      showPassword: 'Show password',
      emailAndPassword: 'Email & Password',
      ssoLogin: 'SSO Login',
      validateOtp: 'Validate OTP',
      resendOtp: 'Resend OTP',
      otp: 'OTP',
      loggingIn: 'Logging in...',
      loginWithSso: 'Login with SSO',
      welcomeBack: 'Welcome back, please login to your account.',
      recoverPassword: 'Recover your password',
      recoverPasswordDesc: "Please enter your email address and we'll send you instructions on how to reset your password.",
      resetPasswordDesc: 'Please enter your new password.',
      backToLogin: 'Back To Login',
      goBackToLogin: 'Go Back To Login',
      forgotPasswordMessage: 'Thanks, check your email for instructions to reset your password.',
      samePassword: '"Password" must be same with "Confirm Password"',
      chooseLoginMethod: 'Choose your login method',
      ssoRedirectInfo: "You'll be redirected to your organization's login page for secure authentication.",
      ssoAccountDetected: 'This email is registered for SSO authentication. Please use the SSO login option.',
      alreadyLoggedIn: 'Already logged in',
      redirectingToDashboard: 'Redirecting to Dashboard...',
      ssoNotAvailable: 'SSO is not available for this account',
      accountNotFound: 'Account not found. Contact your administrator.',
      loginFailed: 'Login failed. Please try again.',
      otpRequired: 'OTP is required.',
      incorrectOtp: 'Incorrect OTP. Please try again.',
      otpValidationFailed: 'OTP validation failed. Please try again.',
      unableToResendOtp: 'Unable to resend OTP. Please try again.',
      ssoAuthFailed: 'SSO authentication failed. Please try again.',
      fillRequiredFields: 'Please fill in all required fields correctly.',
    },

    // Form Fields
    form: {
      required: 'This field is required',
      invalidEmail: 'Please enter a valid email address',
      invalidPhone: 'Please enter a valid phone number',
      minLength: 'Minimum {min} characters required',
      maxLength: 'Maximum {max} characters allowed',
      passwordMismatch: 'Passwords do not match',
      selectOption: 'Please select an option',
      enterValue: 'Please enter a value',
    },

    // Table Headers
    table: {
      item: 'Item',
      description: 'Description',
      quantity: 'Quantity',
      unitCost: 'Unit Cost',
      tax: 'Tax',
      discount: 'Discount',
      subtotal: 'Subtotal',
      total: 'Total',
      transactionId: 'Transaction ID',
      type: 'Type',
      status: 'Status',
      date: 'Date',
      docNo: 'Doc No',
      action: 'Action',
      actions: 'Actions',
      noDataAvailable: 'No data available',
      showingEntries: 'Showing {from} to {to} of {total} entries',
    },

    // Messages
    messages: {
      confirmDelete: 'Confirm to Delete?',
      confirmDeleteMessage: 'Are you sure you want to delete this item?',
      successDeleted: 'Successfully Deleted',
      successDeletedMessage: 'The item has been deleted successfully',
      successSaved: 'Successfully Saved',
      successSavedMessage: 'The changes have been saved successfully',
      successCreated: 'Successfully Created',
      successCreatedMessage: 'The item has been created successfully',
      successUpdated: 'Successfully Updated',
      successUpdatedMessage: 'The item has been updated successfully',
      errorOccurred: 'An error occurred',
      somethingWentWrong: 'Something Went Wrong',
      pleaseWait: 'Please wait...',
      loading: 'Loading...',
      noResults: 'No results found',
      noData: 'No data',
      confirmAction: 'Confirm Action',
      areYouSure: 'Are you sure?',
      operationSuccess: 'Operation successful',
      operationFailed: 'Operation failed',
    },

    // Customer Module
    tenantCustomer: {
      message: {
        ConfirmDelete: 'Confirm to Delete?',
        ConfirmDeleteMessage: 'Are you sure to delete customer "%{item}" ?',
        SuccessDeleted: 'Customer has been Deleted',
        SuccessDeletedMessage: 'The selected customer has been deleted successfully',
        FailedTitle: 'Something Went Wrong',
      },
    },

    // Invoice Module
    invoice: {
      downloadInvoice: 'Download Invoice',
      invoiceDetails: 'Invoice Details',
      lineItems: 'Line Items',
      paymentHistory: 'Payment History',
      relatedDocuments: 'Related Documents',
      message: {
        ConfirmDelete: 'Confirm to Delete?',
        ConfirmDeleteMessage: 'Are you sure to delete invoice "%{item}" ?',
        SuccessDeleted: 'Invoice has been Deleted',
        SuccessDeletedMessage: 'The selected invoice has been deleted successfully',
        FailedTitle: 'Something Went Wrong',
      },
    },

    // Order Module
    order: {
      downloadOrder: 'Download Order',
      orderNo: 'Order No',
      orderItems: 'Order Items',
      irspAction: 'IRSP Action',
      irspStatus: 'IRSP Status',
      irspOrderAction: 'IRSP Order Action',
      irspStatusPanel: 'IRSP Submission Status',
      submitToIrsp: 'Submit',
      convertToInvoice: 'Convert to Invoice',
      convert: 'Convert',
      refreshStatus: 'Refresh Status',
      referenceDocNo: 'Reference Doc No',
      peppolId: 'Peppol ID',
      sgUen: 'SG UEN (InvoiceNow)',
      sgUenPlaceholder: 'e.g. 202200001A',
      supplier: 'Supplier',
      buyer: 'Buyer',
      registration: 'Registration',
      tin: 'TIN',
      taxType: 'Tax Type',
      paymentTerms: 'Payment Terms',
      documentType: 'Document Type',
      overallStatus: 'Overall Status',
      destination: 'Destination',
      irasStatus: 'IRAS Status',
      peppolStatus: 'Peppol Status',
      acknowledgementId: 'Acknowledgement ID',
      buyerResponse: 'Buyer Response',
      submittedAt: 'Submitted At',
      statusMessage: 'Status Message',
      submissionHistory: 'Submission History',
      noIrspSubmission: 'No IRSP submission found for this order.',
      sellerResponses: 'Seller Order Responses',
      response: 'Response',
      totalOrders: 'Total Orders',
      openOrders: 'Open Orders',
      message: {
        confirmDelete: 'Confirm to Delete?',
        confirmDeleteMessage: 'Are you sure to delete order "%{item}" ?',
        deleteSuccessTitle: 'Order has been Deleted',
        deleteSuccessMessage: 'The selected order has been deleted successfully.',
        failedTitle: 'Something Went Wrong',
        noValidDocs: 'No Valid Documents',
        noValidDocsMessage: 'Selected orders are already submitted to IRSP or cannot be submitted.',
        irspSubmitSuccess: 'IRSP Submission Created',
        irspSubmitFailed: 'IRSP Submission Failed',
        statusRefreshed: 'Status Refreshed',
        convertSuccess: 'Conversion Successful',
        enterInvoiceDocNo: 'Enter the Invoice Doc No for the new invoice:',
      },
    },

    // Payment Channel
    paymentChannel: {
      message: {
        ConfirmDelete: 'Confirm to Delete?',
        ConfirmDeleteMessage: 'Are you sure to delete payment channel "%{item}" ?',
        SuccessDeleted: 'Payment Channel has been Deleted',
        SuccessDeletedMessage: 'The selected payment channel has been deleted successfully',
        FailedTitle: 'Something Went Wrong',
      },
    },

    // PDF Setting
    pdfSetting: {
      message: {
        ConfirmDelete: 'Confirm to Delete?',
        ConfirmDeleteMessage: 'Are you sure to delete PDF Setting" ?',
        SuccessDeleted: 'PDF Setting has been Deleted',
        SuccessDeletedMessage: 'The selected PDF Setting has been deleted successfully',
        FailedTitle: 'Something Went Wrong',
      },
    },

    // Legacy keys for backward compatibility
    Dashboard: 'Dashboard',
    Resources: 'Resources',
    Users: 'Users',
    Skills: 'Skills',
    ServiceTypes: 'Service Types',
    ServicePackages: 'Service Packages',
    ServiceGroup: 'Service Group',
    ServiceProviders: 'Service Providers',
    ServiceTickets: 'Service Tickets',
    Feedbacks: 'Feedbacks',
    eCommerce: 'eCommerce',
    Dealers: 'Dealers',
    Roles: 'Roles',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    SystemData: 'System Data',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    'Forgot Password?': 'Forgot Password?',
    'Welcome Back': 'Welcome back, please login to your account.',
    Password: 'Password',
    'Remember Me': 'Remember Me',
    ResetPasswordDesc: 'Please enter your new password.',
    'Go Back To Login': 'Go Back To Login',
    Reset: 'Reset',
    RecoverPassword: 'Recover your password',
    SamePassword: '"Password" must be same with "Confirm Password"',
    RecoverPasswordDesc: "Please enter your email address and we'll send you instructions on how to reset your password.",
    'Back To Login': 'Back To Login',
    'Recover Password': 'Recover Password',
    ForgotPasswordMessage: 'Thanks, check your email for instructions to reset your password.',
    'Add New': 'Add New',
    'System Data': 'System Data',
    Continue: 'Continue',
  },

  zh: {
    // Navigation Menu
    nav: {
      // Simplified sidebar (plain-language menu names)
      eInvoicing: '电子发票',
      reports: '报告',
      help: '帮助',
      supplierInvoices: '供应商发票',
      supplierCreditNotes: '供应商贷项通知单',
      supplierDebitNotes: '供应商借项通知单',
      supplierRefundNotes: '供应商退款单',
      selfBilled: '自开发票',
      paymentsReceived: '已收款项',
      lhdnEInvoices: 'LHDN 电子发票',
      peppolEInvoices: 'Peppol 电子发票',
      supplierEInvoicesLhdn: '供应商电子发票 (LHDN)',
      supplierEInvoicesPeppol: '供应商电子发票 (Peppol)',
      supplierInvoicesToRespond: '待回复的供应商发票',
      lhdnSubmissionHistory: 'LHDN 提交记录',
      peppolSubmissionHistory: 'Peppol 提交记录',
      submissionHistory: '提交记录',
      companySettings: '公司设置',
      imports: '导入记录',
      rptReconciliation: '对账',
      rptEInvoiceStatus: '电子发票状态',
      rptValidatedSales: '已验证销售',
      rptMonthlySales: '月度销售',
      rptValidatedPurchases: '已验证采购',
      rptSupplierEInvoices: '供应商电子发票',
      rptEmailDelivery: '邮件发送记录',
      rptAllDocuments: '所有单据',
      rptPeppolDelivery: 'Peppol 传输状态',
      rptPeppolCompliance: 'Peppol 月度合规',
      rptPeppolReconciliation: 'Peppol 对账',
      sales: '销售',
      purchases: '采购',
      eInvoiceExchange: '电子发票交换',
      selfBilledDocs: '自开单据',
      expenseDoc: '费用单据',
      lhdnEInvoice: 'LHDN 电子发票',
      peppolEInvoice: 'Peppol 电子发票',
      peppolSubmissions: '提交',
      apInvoices: '应付发票',
      sectionReports: '报表',
      sectionBusiness: '业务',
      sectionAdmin: '管理',
      sectionHelp: '帮助',
      myPeppolSubmissions: 'Peppol 提交',
      submissions: '提交',
      lhdn: 'LHDN',
      peppol: 'Peppol',
      receivedDocumentsAp: '收到的单据 (AP)',
      dashboard: '仪表盘',
      eInvoiceDashboard: '电子发票仪表盘',
      reportingDashboard: '报表仪表盘',
      peppolDashboard: 'Peppol 仪表盘',
      peppolReporting: 'Peppol 报表',
      peppolTransmissionStatusReport: '传输状态报表',
      peppolMonthlyComplianceReport: '月度合规报表',
      peppolReconciliationReport: '对账报表',
      reconciliationReport: '对账报表',
      eDocumentByStatusReport: '电子文档状态报表',
      proofOfIncomeValidationReport: '收入证明验证报表',
      proofOfIncomeMonthlyReport: '收入证明月报表',
      proofOfExpensesValidationReport: '费用证明验证报表',
      emailLogsReport: '邮件日志报表',
      advancedReporting: '高级报表',
      apDocuments: '应付文档',
      documentLedger: '文档台账',
      customers: '客户',
      customerGroups: '客户分组',
      proFormaInvoices: '形式发票',
      billingDocs: '账单文档',
      invoices: '发票',
      creditNotes: '贷项通知单',
      debitNotes: '借项通知单',
      refundNotes: '退款单',
      consolidatedInvoices: '合并发票',
      expenseDocs: '费用文档',
      selfBilledInvoices: '自开发票',
      selfBilledCreditNotes: '自开贷项通知单',
      selfBilledDebitNotes: '自开借项通知单',
      selfBilledRefundNotes: '自开退款单',
      eInvoices: '电子发票',
      lhdnSubmissions: 'LHDN 提交',
      sgPeppolSubmissions: '新加坡 Peppol 提交',
      receivedOrders: '收到的订单',
      receivedInvoices: '收到的发票',
      orders: '订单',
      auditTrail: '审计记录',
      files: '文件',
      payments: '付款',
      settings: '设置',
      setting: '设置',
      pdfTemplates: 'PDF 模板',
      roles: '角色',
      users: '用户',
      faq: '常见问题',
      aboutUs: '关于我们',
      privacyPolicy: '隐私政策',
      termsAndConditions: '条款和条件',
      csvImportGuide: 'CSV 导入指南',
      smartPos: 'SmartPos',
    },

    // Page Titles
    pageTitle: {
      dashboard: '仪表盘',
      display: '查看',
      arautomationdashboard: '应收账款自动化仪表盘',
      einvoicedashboard: '电子发票仪表盘',
      emaillogsreportdashboard: '邮件日志报表仪表盘',
      reconciliationreportdashboard: '对账报表仪表盘',
      edocumentbystatusreportdashboard: '电子文档状态报表仪表盘',
      proofofincomevalidationreportdashboard: '收入证明验证报表仪表盘',
      proofofexpensesvalidationreportdashboard: '费用证明验证报表仪表盘',
      proofofincomewaltzreportdashboard: '收入证明月报表仪表盘',
      proofofincomemonthlyreportdashboard: '收入证明月报表仪表盘',
      apdocumentsreport: '应付文档报表',
      documentledgerreport: '文档台账报表',
      csvimportguide: 'CSV 导入指南',
      customers: '客户',
      importcustomers: '导入客户',
      customerdetail: '客户详情',
      customersgroups: '客户分组',
      newcustomersgroups: '新建客户分组',
      customergroupdetail: '客户分组详情',
      emaillogs: '邮件日志',
      displaylog: '查看日志',
      files: '文件',
      displayfile: '查看文件',
      invoices: '发票',
      importinvoices: '导入发票',
      displayinvoice: '查看发票',
      proformainvoices: '形式发票',
      importproformainvoices: '导入形式发票',
      displayproformainvoice: '查看形式发票',
      creditnotes: '贷项通知单',
      importcreditnotes: '导入贷项通知单',
      displaycreditnote: '查看贷项通知单',
      debitnotes: '借项通知单',
      importdebitnotes: '导入借项通知单',
      displaydebitnotes: '查看借项通知单',
      refundnotes: '退款单',
      importrefundnotes: '导入退款单',
      displayrefundnote: '查看退款单',
      selfbilleddocuments: '自开票据',
      selfbilledinvoices: '自开发票',
      selfbilledcreditnotes: '自开贷项通知单',
      selfbilleddebitnotes: '自开借项通知单',
      selfbilledrefundnotes: '自开退款单',
      importselfbilleddocuments: '导入自开票据',
      displayselfbilleddocument: '查看自开票据',
      consolidatedinvoices: '合并发票',
      importconsolidatedinvoices: '导入合并发票',
      displayconsolidatedinvoice: '查看合并发票',
      einvoices: '电子发票',
      displayeinvoice: '查看电子发票',
      lhdnsubmissions: 'LHDN 提交',
      displaylhdnsubmission: '查看 LHDN 提交',
      sgpeppolsubmissions: '新加坡 Peppol 提交',
      displaysgpeppolsubmission: '查看新加坡 Peppol 提交',
      payments: '付款',
      newpayment: '新建付款',
      displaypayment: '查看付款',
      setting: '设置',
      settingdetail: '设置详情',
      pdftemplates: 'PDF 模板',
      roles: '角色',
      smartpos: 'SmartPos',
    },

    // Dashboard
    dashboard: {
      arAutomationDashboard: '应收账款自动化仪表盘',
      welcomeMessage: '欢迎使用智能发票平台应收账款自动化部分。',
      eInvoiceWelcome: '欢迎使用智能发票平台电子发票部分。',
      reportingWelcome: '欢迎使用智能发票平台报表仪表盘。',
      arBalance: '应收账款余额',
      openInvoices: '未结发票',
      overdueAmount: '逾期金额',
      documents: '文档',
      totalDocumentCounts: '文档总数',
      navigation: '导航',
      from: '从：',
      to: '至：',
      apply: '应用',
      applyReport: '查询',
      thisMonth: '本月',
      today: '今天',
      fetchAllDates: '获取所有日期',
      selectDateRange: '选择日期范围',
      selectCreatedDateRange: '选择创建日期范围',
      selectValidatedDateRange: '选择验证日期范围',
      collections: '收款',
      invoiced: '已开票',
      collected: '已收款',
      arAging: '应收账款账龄',
      topDebtors: '主要欠款客户',
      age: '账龄',
      numInvoice: '发票数',
      total: '合计',
      balance: '余额',
      daysOld: '天',
      results: '结果',
      totalInbound: '入站总数',
      totalOpen: '待处理总数',
      totalEinvoice: '电子发票总数',
      eDocumentsByStatus: '按状态分类的电子文档',
      eDocumentsByType: '按类型分类的电子文档',
      openPendingCreation: '待开票/待创建的电子文档类型',
      byStatus: '按状态',
      reconciliationReport: '对账报表',
      exportCsv: '导出 CSV',
      eDocumentType: '电子文档类型',
      inboundCount: '入站数量',
      preCreation: '预创建',
      readyToSubmit: '待提交',
      missingInfo: '信息缺失',
      submitted: '已提交',
      valid: '有效',
      invalid: '无效',
      rejected: '已拒绝',
      accepted: '已接受',
      error: '错误',
      peppolWelcome: '欢迎使用智能发票平台 Peppol 仪表盘。',
      peppolReportingWelcome: '欢迎使用智能发票平台 Peppol 报表。',
      peppolMonthlyComplianceWelcome: '欢迎使用智能发票平台 Peppol 月度合规报表。',
      peppolReconciliationWelcome: '欢迎使用智能发票平台 Peppol 对账报表。',
      myPeppolWelcome: '欢迎使用智能发票平台马来西亚 Peppol 仪表盘。',
      myPeppolReportingWelcome: '欢迎使用智能发票平台马来西亚 Peppol PA 报表。',
      myPeppolMonthlyComplianceWelcome: '欢迎使用智能发票平台马来西亚 Peppol PA 月度合规报表。',
      myPeppolReconciliationWelcome: '欢迎使用智能发票平台马来西亚 Peppol PA 对账报表。',
      peppolByStatus: '按状态划分的 Peppol 提交',
      myPeppolByStatus: '按状态划分的马来西亚 Peppol 提交',
      peppolByDelivery: '投递状态（Peppol / IRAS / 路由）',
      totalSubmissions: '提交总数',
      totalDocumentsTransmitted: '已传输文档总数',
      totalDocuments: '文档总数',
      successful: '成功',
      failed: '失败',
      inProgress: '处理中',
      errorsRejected: '错误 / 已拒绝',
      notApplicable: '不适用',
      channel: '渠道',
      delivery: '投递',
      peppolTransmissionStatusReportTitle: 'Peppol 传输状态报表',
      peppolMonthlyComplianceReportTitle: 'Peppol 管理局月度合规报表',
      peppolReconciliationReportTitle: 'Peppol 对账报表',
      myPeppolTransmissionStatusReportTitle: '马来西亚 Peppol 传输状态报表',
      myPeppolMonthlyComplianceReportTitle: '马来西亚 Peppol 管理局月度合规报表',
      myPeppolReconciliationReportTitle: '马来西亚 Peppol 对账报表',
      reportingPeriod: '报告期间',
      fromMonthYear: '从',
      toMonthYear: '至',
      lastTwelveMonths: '最近 12 个月',
      invalidPeriodRange: '"从" 期间必须早于或等于 "至" 期间。',
      month: '月份',
      peppolTransmitted: 'Peppol 已传输',
      successfulTransmissions: '成功传输',
      irasAccepted: 'IRAS 已接受',
      rejectedFailed: '已拒绝 / 失败',
      as4Acknowledged: 'AS4 已确认',
      as4Errored: 'AS4 错误',
      as4MessageId: 'AS4 消息 ID',
      generatedAt: '生成时间',
      downloadSubmissionCsv: '下载提交 CSV',
      downloadDocumentCsv: '下载文档 CSV',
      routeC3C5: 'Peppol + IRAS (C3C5)',
      routeC5: '仅 IRAS (C5)',
      outcome: '结果',
      transmitted: '已传输',
      needsAttention: '需要关注的提交',
      noGapsFound: '未发现差异。所有提交均已成功传输。',
      totalCount: '总数',
      summaryByStatus: '按状态汇总',
      transactionCount: '交易笔数',
      documentByStatusReport: '按状态的文档报表',
      noDataAvailable: '暂无数据',
      filterByStatus: '按状态筛选',
      all: '全部',
      eDocumentDate: '电子文档日期',
      eDocumentNumber: '电子文档编号',
      uniqueIdentifierNumber: '唯一标识号 (UIN)',
      validationDate: '验证日期',
      buyerName: '买方名称',
      sellerName: '卖方名称',
      submissionDate: '提交日期',
      transactionReport: '交易报表',
      sortedBasedOnCreatedDate: '- 按创建日期排序',
      sortedBasedOnValidatedDate: '- 按验证日期排序',
      buyerId: '买方 ID',
      myrEquivalent: '马币等值',
      invoiceAmount: '发票金额',
      crDrAdjusted: '贷/借调整',
      lhdnValidationDate: 'LHDN 验证日期',
      no: '序号',
      previous: '上一页',
      next: '下一页',
      page: '页',
      rows: '行',
      reportBasedOnValidationDate: '按验证日期报表',
      reportBasedOnCreationDate: '按创建日期报表',
      monthAndYear: '月份和年份',
      month1: '一月',
      month2: '二月',
      month3: '三月',
      month4: '四月',
      month5: '五月',
      month6: '六月',
      month7: '七月',
      month8: '八月',
      month9: '九月',
      month10: '十月',
      month11: '十一月',
      month12: '十二月',
      totalEmails: '邮件总数',
      success: '成功',
      failure: '失败',
      resendEmail: '重新发送邮件',
      srNo: '序号',
      documentNumber: '文档编号',
      recipientEmail: '收件人邮箱',
      failedAt: '失败时间',
      resend: '重发',
      invoice: '发票',
      proForma: '形式发票',
      creditNote: '贷项通知单',
      debitNote: '借项通知单',
      refundNote: '退款单',
      consolidated: '合并发票',
      consolidatedInvoice: '合并发票',
      selfBilledInvoice: '自开发票',
      selfBilledCreditNote: '自开贷项通知单',
      selfBilledDebitNote: '自开借项通知单',
      selfBilledRefundNote: '自开退款单',
      open: '待处理',
      processing: '处理中',
      paid: '已付款',
      close: '已关闭',
      cancelled: '已取消',
      name: '名称',
      numberOfCustomer: '客户数量',
      action: '操作',
      newCustomerGroup: '新建客户分组',
      customer: '客户',
      allDocuments: '所有文档',
      receivables: '应收账款 (AR)',
      payables: '应付账款 (AP)',
      totalReceivables: '应收账款总额 (AR)',
      totalPayables: '应付账款总额 (AP)',
      netPosition: '净头寸',
      netReceivable: '净应收',
      netPayable: '净应付',
      documents: '文档',
      selectIssuedDateRange: '选择开票日期范围',
      filterOptions: '筛选选项',
      category: '类别',
      allCategories: '所有类别',
      arRegular: 'AR 常规',
      arSelfBilled: 'AR 自开票',
      apReceived: 'AP 已接收',
      status: '状态',
      allStatuses: '所有状态',
      documentType: '文档类型',
      allTypes: '所有类型',
      counterparty: '交易对手',
      searchCounterparty: '搜索交易对手...',
      currency: '币种',
      allCurrencies: '所有币种',
      unpaidOnly: '仅未付款 (AR)',
      overdueOnly: '仅逾期 (AR)',
      hasEInvoice: '有电子发票',
      clearFilters: '清除筛选',
      documentCount: '文档数量',
      totalAmount: '总金额',
      documentLedgerReport: '文档分类账报表',
      exportExcel: '导出 Excel',
      exportPdf: '导出 PDF',
      no: '序号',
      direction: '方向',
      documentNo: '文档编号',
      type: '类型',
      counterpartyTin: '交易对手税号',
      issuedDate: '开票日期',
      dueReceivedDate: '到期/接收日期',
      exclTax: '不含税',
      tax: '税额',
      eInvoiceStatus: '电子发票状态',
      lhdnUuid: 'LHDN UUID',
      accumulatingTotal: '累计总额',
      thisYear: '今年',
      showing: '显示',
      to: '至：',
      of: '的',
      entries: '条目',
      rowsPerPage: '每页行数',
      documentLedger: '文档分类账 - 所有应收账款 (AR) 和应付账款 (AP) 文档的统一视图',
      recordPerPage: '每页记录数',
      bulkImport: '批量导入',
      submitForValidation: '提交验证',
      consolidateInvoices: '合并发票',
      exportCsvReport: '导出 CSV 报表',
      exportSelected: '导出所选',
      docNo: '文档编号',
      dueAt: '到期日',
      date: '日期',
      selectPdfTemplate: '选择 PDF 模板',
      general: '常规',
      documentTypeRequired: '文档类型 *',
      printType: '打印类型',
      customiseTemplate: '自定义模板',
      pageMargin: '页边距',
      leftMargin: '左边距 *',
      topMargin: '上边距 *',
      rightMargin: '右边距 *',
      bottomMargin: '下边距 *',
      filter: '筛选',
      customerId: '客户编号',
      customerName: '客户名称',
      parentCustomer: '上级客户',
      email: '邮箱',
      phone: '电话',
      reference1: '参考编号 1',
      reference2: '参考编号 2',
      reference3: '参考编号 3',
      dueDateFrom: '到期日从',
      dueDateTo: '到期日至',
      creationDateFrom: '创建日期从',
      creationDateTo: '创建日期至',
      updateDateFrom: '更新日期从',
      updateDateTo: '更新日期至',
      showPendingEInvoice: '仅显示待创建电子发票',
      amount: '金额',
      amountFrom: '金额从',
      amountTo: '金额至',
      transactionType: '交易类型',
      paymentChannel: '支付渠道',
      submissionDateFrom: '提交日期从',
      submissionDateTo: '提交日期至',
      lhdnStatus: 'LHDN 状态',
      submissionId: '提交编号',
      uuid: 'UUID',
      buyerTin: '买方税号',
      buyerName: '买方名称',
      supplierTin: '供应商税号',
      supplierName: '供应商名称',
      fileName: '文件名',
      fileType: '文件类型',
      uploadDateFrom: '上传日期从',
      uploadDateTo: '上传日期至',
      invoiceNo: '发票编号',
      id: 'ID',
      type: '类型',
      types: '类型',
      transactionId: '交易编号',
      dateFrom: '日期从',
      dateTo: '日期至',
      exported: '已导出',
      eInvoiceId: '电子发票编号',
      sgPeppolStatus: 'SG Peppol 状态',
      sgUen: 'SG UEN（InvoiceNow）',
      sgUenPlaceholder: '例：202200001A',
      irasStatus: 'IRAS 状态',
      destination: '目的地',
      acknowledgementId: '确认 ID',
      buyerResponse: '买方回复',
      sent: '已发送',
      completed: '已完成',
      customerSupplier: '客户 / 供应商',
      createdAt: '创建时间',
      submittedAt: '提交时间',
      updatedAt: '更新时间',
      submitToLhdn: '提交至 LHDN',
      bulkPdfDownload: '批量下载 PDF',
      refreshPage: '刷新',
      submitToSgPeppol: '提交',
      viewDetails: '查看详情',
      download: '下载',
      cancel: '取消',
      void: '作废',
      na: '无',
      applyInvoice: '应用发票',
      supplier: '供应商',
      bulkDelete: '批量删除',
      appliedToInvoice: '已应用到发票',
      description: '描述',
      internalId: '内部编号',
      transactionId: '交易编号',
      export: '导出',
      refresh: '刷新',
      completedAt: '完成时间',
      emailFrom: '发件人',
      emailTo: '收件人',
      usersRoleManagement: '用户角色管理',
      searchUsers: '按姓名或邮箱搜索用户...',
      addNewUser: '添加新用户',
      userName: '用户名',
      role: '角色',
      actions: '操作',
      setUserInactive: '设置用户为非活跃状态',
      sgPeppolSubmissions: 'SG Peppol 提交',
      docs: '文档数',
      route: '路由',
      peppol: 'Peppol',
      iras: 'IRAS',
      basic: '基本信息',
      groupName: '群组名称',
      customers: '客户',
      downloadEInvoice: '下载电子发票',
      downloading: '下载中...',
      viewPayload: '查看数据',
      overview: '概览',
      invoiceNo: '发票编号',
      irbmNo: 'IRBM 编号',
      eInvoiceType: '电子发票类型',
      eInvoiceVersion: '电子发票版本',
      exchangeRate: '汇率',
      exportInvoices: '导出发票',
      registrationTypeNo: '注册类型 / 编号',
      save: '保存',
      close: '关闭',
      back: '返回',
      searchByTransactionId: '按交易编号搜索',
      selectStatus: '选择状态',
      selectRoute: '选择路由',
      selectDocumentType: '选择文档类型',
      paymentChannelSetting: '支付渠道设置',
      newPaymentChannel: '新增支付渠道',
      provider: '服务商',
      customerGroup: '客户分组',
      emailSmtpSetting: '邮件 SMTP 设置',
      newSmtpSetting: '新增 SMTP 设置',
      host: '主机',
      port: '端口',
      user: '用户',
      tenantInfo: '租户信息',
      updateTenantInfo: '更新租户信息',
      tin: '税号',
      registrationNo: '注册号',
      sst: 'SST',
      contactNo: '联系电话',
      mailingAutomationSetting: '邮件自动化设置',
      updateMailingAutomation: '更新邮件自动化',
      sendEmailUponCreation: '创建时发送邮件',
      sendEmailUponValidated: '验证时发送邮件',
      sendEmailUponAdhocImported: '临时导入时发送邮件',
      sendEmailUponAdhocValidated: '临时验证时发送邮件',
      enabledCustomerGroup: '已启用客户分组',
      enabledDocumentType: '已启用文档类型',
      enabled: '已启用',
      disabled: '已禁用',
      einvoiceAutomationSetting: '电子发票自动化设置',
      updateEinvoiceAutomation: '更新电子发票自动化',
      createEinvoiceUponImported: '导入时创建电子发票',
      submitEinvoiceUponValidated: '验证时提交电子发票',
      otpSetting: 'OTP 设置',
      updateOtpSetting: '更新 OTP 设置',
      isTenantOtpEnabled: '是否启用租户 OTP',
      isPayeeOtpEnabled: '是否启用付款人 OTP',
      sgPeppolSetting: 'SG Peppol (InvoiceNow) 设置',
      configureSgPeppol: '配置 SG Peppol',
      singaporeUen: '新加坡 UEN',
      peppolId: 'Peppol ID',
      gstRegistrationNo: 'GST 注册号',
      irasC5UserId: 'IRAS C5 用户 ID',
      verificationStatus: '验证状态',
      active: '活跃',
      inactive: '未激活',
      verified: '已验证',
      pending: '待处理',
      logoImage: '徽标图片',
      letterHeadImage: '信头图片',
      footerImage: '页脚图片',
      update: '更新',
      pdfTemplates: 'PDF 模板',
      addTemplate: '添加模板',
      templateName: '模板名称',
      customised: '自定义',
      uploadFile: '上传文件',
      importErrors: '导入错误',
      previewData: '预览数据',
      clearFile: '清除文件',
      download: '下载',
      downloadCreditNote: '下载贷项通知单',
      downloadDebitNote: '下载借项通知单',
      downloadInvoice: '下载发票',
      unitCost: '单价',
      appliedAmount: '已应用金额',
      appliedAt: '应用时间',
      appliedTo: '应用至',
      lhdnUuid: 'LHDN UUID',
      searchTin: '搜索税号',
      sstNumber: 'SST 号码',
      emailForLhdn: 'LHDN 邮箱地址',
      contactEmailAddress: '联系邮箱地址',
      paymentTerm: '付款条款',
      paymentTermType: '付款条款类型',
      netPaymentTermDay: '净付款天数',
      address: '地址',
      addressNum: '地址编号',
      address1: '地址 1',
      address2: '地址 2',
      postalCode: '邮政编码',
      city: '城市',
      state: '州/省',
      country: '国家',
      others: '其他',
      draftEmail: '草稿邮件',
      draftMessage: '草稿消息',
      sendToPeppol: '发送至 Peppol',
      peppolData: 'Peppol 数据',
      senderId: '发送方 ID',
      receiverId: '接收方 ID',
      codeNumber: '代码编号',
      customerTin: '客户税号',
      userInformation: '用户信息',
      companyRegistrationNo: '公司注册号',
      tourismRegistrationNo: '旅游注册号',
      msicCode: 'MSIC 代码',
      businessActivityDescription: '业务活动描述',
      activateIdleTimeOut: '激活空闲超时',
      maxUserCount: '最大允许用户数',
      addressLine1: '地址行 1',
      addressLine2: '地址行 2',
      addressPostal: '地址邮编',
      addressCity: '地址城市',
      supportEmailAddress: '支持邮箱地址',
      digitalSignature: '数字签名',
      supplierBankNumber: '供应商银行号码',
      fractionDigits: '小数位数',
      businessStationery: '商务信纸',
      letterHead: '信头',
      footer: '页脚',
      note: '备注',
      submit: '提交',
      roleManagement: '角色管理',
      searchRoles: '搜索角色...',
      roleName: '角色名称',
      permissions: '权限',
      userType: '用户类型',
      password: '密码',
      emailSmtp: '邮件 SMTP',
      setCustomerAccess: '设置客户访问权限',
      customTemplate: '自定义模板',
      standardTemplates: '标准模板',
      header: '头部',
      body: '正文',
      notActivated: '未激活',
      sgPeppolConfiguration: '新加坡 Peppol (InvoiceNow) 配置',
      accountInfo: '账户信息',
      whatsappMessage: 'WhatsApp 消息',
      paidAt: '付款时间',
      dueDate: '到期日',
      invoiceDiscount: '发票折扣',
      totalDiscount: '总折扣',
      totalTax: '总税额',
      balance: '余额',
      remarks: '备注',
      invoiceItems: '发票项目',
      eInvoiceSubmittedDate: '电子发票提交日期',
      eInvoiceValidationUrl: '电子发票验证链接',
      eInvoiceValidatedDate: '电子发票验证日期',
      expandSupplierDetails: '展开供应商详情',
      hideSupplierDetails: '收起供应商详情',
      expandBuyerDetails: '展开买方详情',
      hideBuyerDetails: '收起买方详情',
      expandRecipientDetails: '展开收件人详情',
      hideRecipientDetails: '收起收件人详情',
      expandTaxDetails: '展开税务详情',
      hideTaxDetails: '收起税务详情',
      expandCustomFormDetails: '展开 customs 表单详情',
      hideCustomFormDetails: '收起 customs 表单详情',
      showTaxDetails: '显示税务详情',
      hideTaxDetailsTooltip: '收起税务详情',
      supplier: '供应商',
      buyer: '买方',
      recipient: '收件人',
      editItem: '编辑项目',
      edit: '编辑',
      supplierName: '供应商名称 *',
      supplierTin: '供应商税号 *',
      supplierTourismRegistration: '供应商旅游注册',
      supplierMsicCode: '供应商马来西亚标准行业分类 (MSIC) 代码 *',
      supplierBusinessActivity: '供应商业务活动描述 *',
      supplierEmail: '供应商邮箱',
      supplierAddressNum: '供应商地址编号 *',
      supplierAddressLine1: '供应商地址行 1',
      supplierAddressLine2: '供应商地址行 2',
      supplierAddressPostal: '供应商地址邮编 *',
      supplierAddressCity: '供应商地址城市 *',
      supplierContactNumber: '供应商联系电话 *',
      supplierState: '供应商州/省 *',
      supplierCountry: '供应商国家 *',
      supplierSst: '供应商 SST',
      buyerName: '买方名称 *',
      buyerTin: '买方税号 *',
      buyerEmail: '买方邮箱',
      buyerAddressNum: '买方地址编号 *',
      buyerAddressLine1: '买方地址行 1',
      buyerAddressLine2: '买方地址行 2',
      buyerAddressPostal: '买方地址邮编 *',
      buyerAddressCity: '买方地址城市 *',
      buyerContactNumber: '买方联系电话 *',
      buyerAddressState: '买方地址州/省 *',
      buyerCountry: '买方国家 *',
      buyerSst: '买方 SST',
      recipientName: '收件人名称',
      recipientTin: '收件人税号',
      recipientRegistration: '收件人注册号',
      recipientAddressNum: '收件人地址编号',
      recipientAddressLine1: '收件人地址行 1',
      recipientAddressLine2: '收件人地址行 2',
      recipientAddressPostal: '收件人地址邮编',
      recipientAddressCity: '收件人地址城市',
      recipientAddressState: '收件人地址州/省',
      recipientAddressCountry: '收件人地址国家',
      taxInfo: '税务信息',
      taxExemptionReason: '税务豁免原因',
      totalTaxAmountPerTaxType: '各税种税额合计',
      totalTaxableAmountPerTaxType: '各税种应税金额合计',
      totalExemptionAmount: '豁免金额合计',
      customsFormDetails: '海关表单详情',
      customForm: '海关表单',
      customsReferenceNum: '海关参考编号',
      customsReferenceNum2: '海关参考编号 2',
      incoterms: '国际贸易术语',
      irbmInfo: 'IRBM 信息',
      missingItems: '缺失项目',
      submissionErrors: '提交错误',
      cancellationResponse: '取消响应',
      cancellationReason: '取消原因',
      editLineItem: '编辑行项目',
      classification: '分类',
      uom: '计量单位',
      taxExemptionAmount: '税务豁免金额',
      taxBreakdown: '税务明细',
      taxTypeHeader: '税种',
      taxRate: '税率 %',
      discountRate: '折扣率',
      lineTotal: '行合计',
      taxCategory: '税种分类',
      unit: '单位',
      id: 'ID',
      taxableAmount: '应税金额',
      taxAmount: '税额',
      reason: '原因',
      invoiceLineItems: '发票行项目',
      downloadPayload: '下载数据',
      searchTin: '搜索税号',
      bulkImport: '批量导入',
      bulkApply: '批量应用',
      bulkImportCustomers: '批量导入客户到智能发票平台。',
      bulkImportConsolidatedInvoices: '批量导入合并发票到智能发票平台。',
      bulkImportProForma: '批量导入形式发票到智能发票平台。',
      bulkImportSelfBilled: '批量导入自开发票到智能发票平台。',
      bulkImportDebitNote: '批量导入借项通知单到智能发票平台。',
      bulkImportRefundNotes: '批量导入退款单到智能发票平台。',
      bulkImportCreditNotes: '批量导入贷项通知单到智能发票平台。',
      bulkImportCustomersToGroup: '批量导入客户到此客户分组。',
      paymentFrom: '付款来源',
      applyPaymentTo: '应用付款至',
      uploadAttachments: '上传附件',
      chequeInfo: '支票信息',
      onlinePaymentInfo: '在线付款信息',
      paymentChannel: '付款渠道',
      items: '项目',
      itemsCount: '项目',
      item: '项目',
      quantity: '数量',
      tax: '税',
      discount: '折扣',
      subtotal: '小计',
      payments: '付款',
      proForma: '形式发票',
      creditNotes: '贷项通知单',
      debitNotes: '借项通知单',
      refundNotes: '退款单',
      attachments: '附件',
      file: '文件',
      phone: '电话',
      emailAddress: '邮箱地址',
      appliedToInvoice: '应用至发票',
      standard: '标准',
      reference1: '参考 1',
      reference2: '参考 2',
      reference3: '参考 3',
      verify: '验证',
      currencyCode: '货币代码',
      registrationType: '注册类型',
      updateTenantInfo: '更新租户信息',
      minFractionDigitsPrice: '最小价格小数位数',
      maxFractionDigitsPrice: '最大价格小数位数',
      minFractionDigitsQuantity: '最小数量小数位数',
      maxFractionDigitsQuantity: '最大数量小数位数',
      minFractionDigitsAmount: '最小金额小数位数',
      maxFractionDigitsAmount: '最大金额小数位数',
      userDefinedDateFormat: '用户自定义日期格式',
      rightMargin: '右边距',
      bottomMargin: '下边距',
      select: '选择',
      preview: '预览',
      upload: '上传',
      processing: '处理中...',
      currency: '货币',
      amount: '金额',
      bulkImportInvoices: '批量导入发票到智能发票平台。',
    },

    // Common Actions
    actions: {
      add: '添加',
      addNew: '新增',
      edit: '编辑',
      delete: '删除',
      save: '保存',
      cancel: '取消',
      confirm: '确认',
      search: '搜索',
      filter: '筛选',
      export: '导出',
      clear: '清除',
      import: '导入',
      download: '下载',
      upload: '上传',
      view: '查看',
      close: '关闭',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      reset: '重置',
      clear: '清除',
      select: '选择',
      selectAll: '全选',
      copy: '复制',
      print: '打印',
      refresh: '刷新',
      update: '更新',
      create: '创建',
      send: '发送',
      resend: '重新发送',
      approve: '批准',
      reject: '拒绝',
      continue: '继续',
    },

    // Common Labels
    labels: {
      name: '名称',
      email: '邮箱',
      phone: '电话',
      address: '地址',
      date: '日期',
      time: '时间',
      status: '状态',
      type: '类型',
      description: '描述',
      amount: '金额',
      total: '总计',
      subtotal: '小计',
      tax: '税额',
      discount: '折扣',
      quantity: '数量',
      unitPrice: '单价',
      unitCost: '单位成本',
      price: '价格',
      item: '项目',
      items: '项目',
      customer: '客户',
      supplier: '供应商',
      invoice: '发票',
      invoiceNo: '发票号',
      invoiceNumber: '发票号码',
      documentNo: '文档号',
      reference: '参考',
      notes: '备注',
      remarks: '说明',
      currency: '货币',
      paymentMethod: '付款方式',
      paymentStatus: '付款状态',
      dueDate: '到期日',
      issueDate: '开票日期',
      createdAt: '创建时间',
      updatedAt: '更新时间',
      createdBy: '创建人',
      overview: '概览',
      details: '详情',
      summary: '摘要',
      history: '历史',
      all: '全部',
      active: '活跃',
      inactive: '非活跃',
      pending: '待处理',
      approved: '已批准',
      rejected: '已拒绝',
      draft: '草稿',
      sent: '已发送',
      paid: '已付款',
      unpaid: '未付款',
      overdue: '已逾期',
      cancelled: '已取消',
      completed: '已完成',
      processing: '处理中',
      failed: '失败',
      success: '成功',
    },

    // Authentication
    auth: {
      login: '登录',
      logout: '退出',
      register: '注册',
      password: '密码',
      confirmPassword: '确认密码',
      newPassword: '新密码',
      currentPassword: '当前密码',
      forgotPassword: '忘记密码？',
      resetPassword: '重置密码',
      rememberMe: '记住我',
      showPassword: '显示密码',
      emailAndPassword: '邮箱和密码',
      ssoLogin: '单点登录',
      validateOtp: '验证一次性密码',
      resendOtp: '重新发送一次性密码',
      otp: '一次性密码',
      loggingIn: '登录中...',
      loginWithSso: '使用单点登录',
      welcomeBack: '欢迎回来，请登录您的账户。',
      recoverPassword: '恢复您的密码',
      recoverPasswordDesc: '请输入您的邮箱地址，我们将向您发送重置密码的说明。',
      resetPasswordDesc: '请输入您的新密码。',
      backToLogin: '返回登录',
      goBackToLogin: '返回登录页面',
      forgotPasswordMessage: '感谢您，请查收您的邮箱获取重置密码的说明。',
      samePassword: '"密码"必须与"确认密码"相同',
      chooseLoginMethod: '选择您的登录方式',
      ssoRedirectInfo: '您将被重定向到您组织的登录页面进行安全认证。',
      ssoAccountDetected: '此邮箱已注册为单点登录认证。请使用单点登录选项。',
      alreadyLoggedIn: '已登录',
      redirectingToDashboard: '正在重定向到仪表盘...',
      ssoNotAvailable: '此账户不支持单点登录',
      accountNotFound: '账户未找到。请联系您的管理员。',
      loginFailed: '登录失败。请重试。',
      otpRequired: '需要一次性密码。',
      incorrectOtp: '一次性密码错误。请重试。',
      otpValidationFailed: '一次性密码验证失败。请重试。',
      unableToResendOtp: '无法重新发送一次性密码。请重试。',
      ssoAuthFailed: '单点登录认证失败。请重试。',
      fillRequiredFields: '请正确填写所有必填字段。',
    },

    // Form Fields
    form: {
      required: '此字段为必填项',
      invalidEmail: '请输入有效的邮箱地址',
      invalidPhone: '请输入有效的电话号码',
      minLength: '最少需要 {min} 个字符',
      maxLength: '最多允许 {max} 个字符',
      passwordMismatch: '密码不匹配',
      selectOption: '请选择一个选项',
      enterValue: '请输入值',
    },

    // Table Headers
    table: {
      item: '项目',
      description: '描述',
      quantity: '数量',
      unitCost: '单位成本',
      tax: '税额',
      discount: '折扣',
      subtotal: '小计',
      total: '总计',
      transactionId: '交易编号',
      type: '类型',
      status: '状态',
      date: '日期',
      docNo: '文档号',
      action: '操作',
      actions: '操作',
      noDataAvailable: '暂无数据',
      showingEntries: '显示第 {from} 到 {to} 条，共 {total} 条',
    },

    // Messages
    messages: {
      confirmDelete: '确认删除？',
      confirmDeleteMessage: '您确定要删除此项目吗？',
      successDeleted: '删除成功',
      successDeletedMessage: '项目已成功删除',
      successSaved: '保存成功',
      successSavedMessage: '更改已成功保存',
      successCreated: '创建成功',
      successCreatedMessage: '项目已成功创建',
      successUpdated: '更新成功',
      successUpdatedMessage: '项目已成功更新',
      errorOccurred: '发生错误',
      somethingWentWrong: '出现错误',
      pleaseWait: '请稍候...',
      loading: '加载中...',
      noResults: '未找到结果',
      noData: '暂无数据',
      confirmAction: '确认操作',
      areYouSure: '您确定吗？',
      operationSuccess: '操作成功',
      operationFailed: '操作失败',
    },

    // Customer Module
    tenantCustomer: {
      message: {
        ConfirmDelete: '确认删除？',
        ConfirmDeleteMessage: '您确定要删除客户 "%{item}" 吗？',
        SuccessDeleted: '客户已删除',
        SuccessDeletedMessage: '所选客户已成功删除',
        FailedTitle: '出现错误',
      },
    },

    // Invoice Module
    invoice: {
      downloadInvoice: '下载发票',
      invoiceDetails: '发票详情',
      lineItems: '明细项目',
      paymentHistory: '付款历史',
      relatedDocuments: '相关文档',
      message: {
        ConfirmDelete: '确认删除？',
        ConfirmDeleteMessage: '您确定要删除发票 "%{item}" 吗？',
        SuccessDeleted: '发票已删除',
        SuccessDeletedMessage: '所选发票已成功删除',
        FailedTitle: '出现错误',
      },
    },

    // Order Module
    order: {
      downloadOrder: '下载订单',
      orderNo: '订单号',
      orderItems: '订单项目',
      irspAction: 'IRSP 操作',
      irspStatus: 'IRSP 状态',
      irspOrderAction: 'IRSP 订单操作',
      irspStatusPanel: 'IRSP 提交状态',
      submitToIrsp: '提交',
      convertToInvoice: '转换为发票',
      convert: '转换',
      refreshStatus: '刷新状态',
      referenceDocNo: '参考文档号',
      peppolId: 'Peppol ID',
      sgUen: 'SG UEN（InvoiceNow）',
      sgUenPlaceholder: '例：202200001A',
      supplier: '供应商',
      buyer: '买方',
      registration: '注册号',
      tin: '税号',
      taxType: '税种',
      paymentTerms: '付款条件',
      documentType: '文档类型',
      overallStatus: '总体状态',
      destination: '目的地',
      irasStatus: 'IRAS 状态',
      peppolStatus: 'Peppol 状态',
      acknowledgementId: '确认 ID',
      buyerResponse: '买方回复',
      submittedAt: '提交时间',
      statusMessage: '状态消息',
      submissionHistory: '提交历史',
      noIrspSubmission: '此订单未找到 IRSP 提交记录。',
      totalOrders: '总订单',
      openOrders: '待处理订单',
      sellerResponses: '卖方订单回复',
      response: '回复',
      message: {
        confirmDelete: '确认删除？',
        confirmDeleteMessage: '您确定要删除订单 "%{item}" 吗？',
        deleteSuccessTitle: '订单已删除',
        deleteSuccessMessage: '所选订单已成功删除。',
        failedTitle: '出现错误',
        noValidDocs: '没有有效文档',
        noValidDocsMessage: '所选订单已提交到 IRSP 或无法提交。',
        irspSubmitSuccess: 'IRSP 提交已创建',
        irspSubmitFailed: 'IRSP 提交失败',
        statusRefreshed: '状态已刷新',
        convertSuccess: '转换成功',
        enterInvoiceDocNo: '请输入新发票的发票文档号：',
      },
    },

    // Payment Channel
    paymentChannel: {
      message: {
        ConfirmDelete: '确认删除？',
        ConfirmDeleteMessage: '您确定要删除付款渠道 "%{item}" 吗？',
        SuccessDeleted: '付款渠道已删除',
        SuccessDeletedMessage: '所选付款渠道已成功删除',
        FailedTitle: '出现错误',
      },
    },

    // PDF Setting
    pdfSetting: {
      message: {
        ConfirmDelete: '确认删除？',
        ConfirmDeleteMessage: '您确定要删除 PDF 设置吗？',
        SuccessDeleted: 'PDF 设置已删除',
        SuccessDeletedMessage: '所选 PDF 设置已成功删除',
        FailedTitle: '出现错误',
      },
    },

    // Legacy keys for backward compatibility
    Dashboard: '仪表盘',
    Resources: '资源',
    Users: '用户',
    Skills: '技能',
    ServiceTypes: '服务类型',
    ServicePackages: '服务套餐',
    ServiceGroup: '服务组',
    ServiceProviders: '服务提供商',
    ServiceTickets: '服务工单',
    Feedbacks: '反馈',
    eCommerce: '电子商务',
    Dealers: '经销商',
    Roles: '角色',
    Apps: '应用',
    Todo: '待办',
    Chat: '聊天',
    Email: '邮件',
    Calendar: '日历',
    FullCalendar: '完整日历',
    SimpleCalendar: '简单日历',
    Shop: '商店',
    ItemDetails: '项目详情',
    Cart: '购物车',
    WishList: '愿望清单',
    Checkout: '结账',
    UI: '界面',
    DataList: '数据列表',
    ListView: '列表视图',
    ThumbView: '缩略图视图',
    Grid: '网格',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: '颜色',
    Card: '卡片',
    Basic: '基础',
    Statistics: '统计',
    Analytics: '分析',
    CardActions: '卡片操作',
    CardColors: '卡片颜色',
    Table: '表格',
    agGridTable: 'agGrid 表格',
    Components: '组件',
    Alert: '警告',
    Avatar: '头像',
    Badge: '徽章',
    Breadcrumb: '面包屑',
    Button: '按钮',
    ButtonGroup: '按钮组',
    Chip: '标签',
    Collapse: '折叠',
    Dialogs: '对话框',
    Divider: '分割线',
    DropDown: '下拉菜单',
    List: '列表',
    Loading: '加载中',
    Navbar: '导航栏',
    Notifications: '通知',
    Pagination: '分页',
    Popup: '弹出框',
    Progress: '进度',
    Sidebar: '侧边栏',
    Slider: '滑块',
    Tabs: '标签页',
    Tooltip: '提示框',
    Upload: '上传',
    FormsAndTable: '表单和表格',
    FormElements: '表单元素',
    Select: '选择',
    Switch: '开关',
    Checkbox: '复选框',
    Radio: '单选框',
    Input: '输入',
    NumberInput: '数字输入',
    Textarea: '文本域',
    FormLayouts: '表单布局',
    FormWizard: '表单向导',
    FormValidation: '表单验证',
    FormInputGroup: '表单输入组',
    Pages: '页面',
    Authentication: '认证',
    Login: '登录',
    Register: '注册',
    ForgotPassword: '忘记密码',
    ResetPassword: '重置密码',
    LockScreen: '锁屏',
    Miscellaneous: '其他',
    ComingSoon: '即将推出',
    Error: '错误',
    404: '404',
    500: '500',
    NotAuthorized: '未授权',
    Maintenance: '维护中',
    Profile: '个人资料',
    User: '用户',
    View: '查看',
    Edit: '编辑',
    UserSettings: '用户设置',
    Invoice: '发票',
    FAQ: '常见问题',
    Search: '搜索',
    KnowledgeBase: '知识库',
    ChartsAndMaps: '图表和地图',
    Charts: '图表',
    ApexCharts: 'Apex 图表',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: '谷歌地图',
    Extensions: '扩展',
    QuillEditor: 'Quill 编辑器',
    DragAndDrop: '拖放',
    Datepicker: '日期选择器',
    DatetimePicker: '日期时间选择器',
    AccessControl: '访问控制',
    I18n: '国际化',
    Carousel: '轮播',
    Clipboard: '剪贴板',
    ContextMenu: '右键菜单',
    StarRatings: '星级评分',
    Autocomplete: '自动完成',
    Tree: '树形',
    Import: '导入',
    Export: '导出',
    ExportSelected: '导出所选',
    Others: '其他',
    MenuLevels: '菜单级别',
    MenuLevel2p1: '菜单级别 2.1',
    MenuLevel2p2: '菜单级别 2.2',
    MenuLevel3p1: '菜单级别 3.1',
    MenuLevel3p2: '菜单级别 3.2',
    DisabledMenu: '禁用菜单',
    Support: '支持',
    Documentation: '文档',
    RaiseSupport: '提交支持',
    demoTitle: '卡片标题',
    SystemData: '系统数据',
    demoText: '蛋糕芝麻糖纸杯蛋糕姜饼丹麦我爱姜饼。苹果派果冻软糖松饼半糖棒棒糖。巧克力蛋糕燕麦蛋糕提拉米苏杏仁糖梅子。甜甜圈甜派燕麦蛋糕糖果水果蛋糕棉花糖柠檬滴。',
    'Forgot Password?': '忘记密码？',
    'Welcome Back': '欢迎回来，请登录您的账户。',
    Password: '密码',
    'Remember Me': '记住我',
    ResetPasswordDesc: '请输入您的新密码。',
    'Go Back To Login': '返回登录页面',
    Reset: '重置',
    RecoverPassword: '恢复您的密码',
    SamePassword: '"密码"必须与"确认密码"相同',
    RecoverPasswordDesc: '请输入您的邮箱地址，我们将向您发送重置密码的说明。',
    'Back To Login': '返回登录',
    'Recover Password': '恢复密码',
    ForgotPasswordMessage: '感谢您，请查收您的邮箱获取重置密码的说明。',
    'Add New': '新增',
    'System Data': '系统数据',
    Continue: '继续',
  },

  ms: {
    // Navigation Menu
    nav: {
      // Simplified sidebar (plain-language menu names)
      eInvoicing: 'e-Invois',
      reports: 'Laporan',
      help: 'Bantuan',
      supplierInvoices: 'Invois Pembekal',
      supplierCreditNotes: 'Nota Kredit Pembekal',
      supplierDebitNotes: 'Nota Debit Pembekal',
      supplierRefundNotes: 'Nota Bayaran Balik Pembekal',
      selfBilled: 'Bil Kendiri',
      paymentsReceived: 'Bayaran Diterima',
      lhdnEInvoices: 'e-Invois LHDN',
      peppolEInvoices: 'e-Invois Peppol',
      supplierEInvoicesLhdn: 'e-Invois Pembekal (LHDN)',
      supplierEInvoicesPeppol: 'e-Invois Pembekal (Peppol)',
      supplierInvoicesToRespond: 'Invois Pembekal untuk Dibalas',
      lhdnSubmissionHistory: 'Sejarah Penghantaran LHDN',
      peppolSubmissionHistory: 'Sejarah Penghantaran Peppol',
      submissionHistory: 'Sejarah Penghantaran',
      companySettings: 'Tetapan Syarikat',
      imports: 'Import',
      rptReconciliation: 'Penyelarasan',
      rptEInvoiceStatus: 'Status e-Invois',
      rptValidatedSales: 'Jualan Disahkan',
      rptMonthlySales: 'Jualan Bulanan',
      rptValidatedPurchases: 'Pembelian Disahkan',
      rptSupplierEInvoices: 'e-Invois Pembekal',
      rptEmailDelivery: 'Penghantaran E-mel',
      rptAllDocuments: 'Semua Dokumen',
      rptPeppolDelivery: 'Status Penghantaran Peppol',
      rptPeppolCompliance: 'Pematuhan Bulanan Peppol',
      rptPeppolReconciliation: 'Penyelarasan Peppol',
      sales: 'Jualan',
      purchases: 'Belian',
      eInvoiceExchange: 'Pertukaran e-Invois',
      selfBilledDocs: 'Dokumen Bil Sendiri',
      expenseDoc: 'Dokumen Perbelanjaan',
      lhdnEInvoice: 'e-Invois LHDN',
      peppolEInvoice: 'e-Invois Peppol',
      peppolSubmissions: 'Penghantaran',
      apInvoices: 'Invois AP',
      sectionReports: 'Laporan',
      sectionBusiness: 'Perniagaan',
      sectionAdmin: 'Pentadbiran',
      sectionHelp: 'Bantuan',
      myPeppolSubmissions: 'Penghantaran Peppol',
      submissions: 'Penghantaran',
      lhdn: 'LHDN',
      peppol: 'Peppol',
      receivedDocumentsAp: 'Dokumen Diterima (AP)',
      dashboard: 'Papan Pemuka',
      eInvoiceDashboard: 'Papan Pemuka E-Invois',
      reportingDashboard: 'Papan Pemuka Laporan',
      peppolDashboard: 'Papan Pemuka Peppol',
      peppolReporting: 'Laporan Peppol',
      peppolTransmissionStatusReport: 'Laporan Status Penghantaran',
      peppolMonthlyComplianceReport: 'Laporan Pematuhan Bulanan',
      peppolReconciliationReport: 'Laporan Penyesuaian',
      reconciliationReport: 'Laporan Penyesuaian',
      eDocumentByStatusReport: 'Laporan eDokumen Mengikut Status',
      proofOfIncomeValidationReport: 'Laporan Pengesahan Bukti Pendapatan',
      proofOfIncomeMonthlyReport: 'Laporan Bulanan Bukti Pendapatan',
      proofOfExpensesValidationReport: 'Laporan Pengesahan Bukti Perbelanjaan',
      emailLogsReport: 'Laporan Log E-mel',
      advancedReporting: 'Laporan Lanjutan',
      apDocuments: 'Dokumen AP',
      documentLedger: 'Lejar Dokumen',
      customers: 'Pelanggan',
      customerGroups: 'Kumpulan Pelanggan',
      proFormaInvoices: 'Invois Pro Forma',
      billingDocs: 'Dokumen Bil',
      invoices: 'Invois',
      creditNotes: 'Nota Kredit',
      debitNotes: 'Nota Debit',
      refundNotes: 'Nota Bayaran Balik',
      consolidatedInvoices: 'Invois Disatukan',
      expenseDocs: 'Dokumen Perbelanjaan',
      selfBilledInvoices: 'Invois Bil Sendiri',
      selfBilledCreditNotes: 'Nota Kredit Bil Sendiri',
      selfBilledDebitNotes: 'Nota Debit Bil Sendiri',
      selfBilledRefundNotes: 'Nota Bayaran Balik Bil Sendiri',
      eInvoices: 'E-Invois',
      lhdnSubmissions: 'Penghantaran LHDN',
      sgPeppolSubmissions: 'Penghantaran SG Peppol',
      receivedOrders: 'Pesanan Diterima',
      receivedInvoices: 'Invois Diterima',
      orders: 'Pesanan',
      auditTrail: 'Jejak Audit',
      files: 'Fail',
      payments: 'Pembayaran',
      settings: 'Tetapan',
      setting: 'Tetapan',
      pdfTemplates: 'Templat PDF',
      roles: 'Peranan',
      users: 'Pengguna',
      faq: 'Soalan Lazim',
      aboutUs: 'Tentang Kami',
      privacyPolicy: 'Dasar Privasi',
      termsAndConditions: 'Terma dan Syarat',
      csvImportGuide: 'Panduan Import CSV',
      smartPos: 'SmartPos',
    },

    // Page Titles
    pageTitle: {
      dashboard: 'Papan Pemuka',
      display: 'Paparan',
      arautomationdashboard: 'PAPAN PEMUKA AUTOMASI AR',
      einvoicedashboard: 'PAPAN PEMUKA E-INVOIS',
      emaillogsreportdashboard: 'Papan Pemuka Laporan Log E-mel',
      reconciliationreportdashboard: 'PAPAN PEMUKA LAPORAN PENYESUAIAN',
      edocumentbystatusreportdashboard: 'PAPAN PEMUKA LAPORAN eDOKUMEN MENGIKUT STATUS',
      proofofincomevalidationreportdashboard: 'PAPAN PEMUKA LAPORAN PENGESAHAN BUKTI PENDAPATAN',
      proofofexpensesvalidationreportdashboard: 'PAPAN PEMUKA LAPORAN PENGESAHAN BUKTI PERBELANJAAN',
      proofofincomewaltzreportdashboard: 'PAPAN PEMUKA LAPORAN BULANAN BUKTI PENDAPATAN',
      proofofincomemonthlyreportdashboard: 'PAPAN PEMUKA LAPORAN BULANAN BUKTI PENDAPATAN',
      apdocumentsreport: 'LAPORAN DOKUMEN AP',
      documentledgerreport: 'LAPORAN LEJAR DOKUMEN',
      csvimportguide: 'PANDUAN IMPORT CSV',
      customers: 'Pelanggan',
      importcustomers: 'Import Pelanggan',
      customerdetail: 'Butiran Pelanggan',
      customersgroups: 'Kumpulan Pelanggan',
      newcustomersgroups: 'Kumpulan Pelanggan Baharu',
      customergroupdetail: 'Butiran Kumpulan Pelanggan',
      emaillogs: 'Log E-mel',
      displaylog: 'Paparan Log',
      files: 'Fail',
      displayfile: 'Paparan Fail',
      invoices: 'Invois',
      importinvoices: 'Import Invois',
      displayinvoice: 'Paparan Invois',
      proformainvoices: 'Invois Pro Forma',
      importproformainvoices: 'Import Invois Pro Forma',
      displayproformainvoice: 'Paparan Invois Pro Forma',
      creditnotes: 'Nota Kredit',
      importcreditnotes: 'Import Nota Kredit',
      displaycreditnote: 'Paparan Nota Kredit',
      debitnotes: 'Nota Debit',
      importdebitnotes: 'Import Nota Debit',
      displaydebitnotes: 'Paparan Nota Debit',
      refundnotes: 'Nota Bayaran Balik',
      importrefundnotes: 'Import Nota Bayaran Balik',
      displayrefundnote: 'Paparan Nota Bayaran Balik',
      selfbilleddocuments: 'Dokumen Bil Sendiri',
      selfbilledinvoices: 'Invois Bil Sendiri',
      selfbilledcreditnotes: 'Nota Kredit Bil Sendiri',
      selfbilleddebitnotes: 'Nota Debit Bil Sendiri',
      selfbilledrefundnotes: 'Nota Bayaran Balik Bil Sendiri',
      importselfbilleddocuments: 'Import Dokumen Bil Sendiri',
      displayselfbilleddocument: 'Paparan Dokumen Bil Sendiri',
      consolidatedinvoices: 'Invois Disatukan',
      importconsolidatedinvoices: 'Import Invois Disatukan',
      displayconsolidatedinvoice: 'Paparan Invois Disatukan',
      einvoices: 'E-Invois',
      displayeinvoice: 'Paparan E-Invois',
      lhdnsubmissions: 'Penghantaran LHDN',
      displaylhdnsubmission: 'Paparan Penghantaran LHDN',
      sgpeppolsubmissions: 'Penghantaran SG Peppol',
      displaysgpeppolsubmission: 'Paparan Penghantaran SG Peppol',
      payments: 'Pembayaran',
      newpayment: 'Pembayaran Baharu',
      displaypayment: 'Paparan Pembayaran',
      setting: 'Tetapan',
      settingdetail: 'Butiran Tetapan',
      pdftemplates: 'Templat PDF',
      roles: 'Peranan',
      smartpos: 'SmartPos',
    },

    // Dashboard
    dashboard: {
      arAutomationDashboard: 'PAPAN PEMUKA AUTOMASI AR',
      welcomeMessage: 'Selamat datang ke Bahagian Automasi AR Platform Invois Pintar.',
      eInvoiceWelcome: 'Selamat datang ke Bahagian E-Invois Platform Invois Pintar.',
      reportingWelcome: 'Selamat datang ke Papan Pemuka Laporan Platform Invois Pintar.',
      arBalance: 'BAKI A/R',
      openInvoices: 'INVOIS TERBUKA',
      overdueAmount: 'JUMLAH TERTUNGGAK',
      documents: 'Dokumen',
      totalDocumentCounts: 'Jumlah Kiraan Dokumen',
      navigation: 'NAVIGASI',
      from: 'Dari:',
      to: 'Hingga:',
      apply: 'Guna',
      applyReport: 'Guna',
      thisMonth: 'Bulan Ini',
      today: 'Hari Ini',
      fetchAllDates: 'Dapatkan Semua Tarikh',
      selectDateRange: 'PILIH JULAT TARIKH',
      selectCreatedDateRange: 'PILIH JULAT TARIKH DICIPTA',
      selectValidatedDateRange: 'PILIH JULAT TARIKH DISAHKAN',
      collections: 'Kutipan',
      invoiced: 'Diinvoiskan',
      collected: 'Dikutip',
      arAging: 'Penuaan A/R',
      topDebtors: 'Penghutang Tertinggi',
      age: 'UMUR',
      numInvoice: '# INVOIS',
      total: 'JUMLAH',
      balance: 'BAKI',
      daysOld: 'Hari',
      results: 'Keputusan',
      totalInbound: 'Jumlah Masuk',
      totalOpen: 'Jumlah Terbuka',
      totalEinvoice: 'Jumlah E-invois',
      eDocumentsByStatus: 'eDokumen Mengikut Status',
      eDocumentsByType: 'eDokumen Mengikut Jenis',
      openPendingCreation: 'Terbuka / menunggu penciptaan mengikut Jenis eDokumen',
      byStatus: 'Mengikut Status',
      reconciliationReport: 'LAPORAN PENYESUAIAN',
      exportCsv: 'Eksport CSV',
      eDocumentType: 'Jenis eDokumen',
      inboundCount: 'Kiraan Masuk',
      preCreation: 'Pra penciptaan',
      readyToSubmit: 'Sedia untuk hantar',
      missingInfo: 'Maklumat Hilang',
      submitted: 'Dihantar',
      valid: 'Sah',
      invalid: 'Tidak Sah',
      rejected: 'Ditolak',
      accepted: 'Diterima',
      error: 'Ralat',
      peppolWelcome: 'Selamat datang ke Papan Pemuka Peppol Platform Invois Pintar.',
      peppolReportingWelcome: 'Selamat datang ke Laporan Peppol Platform Invois Pintar.',
      peppolMonthlyComplianceWelcome: 'Selamat datang ke Laporan Pematuhan Bulanan Peppol Platform Invois Pintar.',
      peppolReconciliationWelcome: 'Selamat datang ke Laporan Penyesuaian Peppol Platform Invois Pintar.',
      myPeppolWelcome: 'Selamat datang ke Papan Pemuka Peppol Malaysia Platform Invois Pintar.',
      myPeppolReportingWelcome: 'Selamat datang ke Laporan PA Peppol Malaysia Platform Invois Pintar.',
      myPeppolMonthlyComplianceWelcome: 'Selamat datang ke Laporan Pematuhan Bulanan PA Peppol Malaysia Platform Invois Pintar.',
      myPeppolReconciliationWelcome: 'Selamat datang ke Laporan Penyesuaian PA Peppol Malaysia Platform Invois Pintar.',
      peppolByStatus: 'Penghantaran Peppol Mengikut Status',
      myPeppolByStatus: 'Penghantaran Peppol Malaysia Mengikut Status',
      peppolByDelivery: 'Status Penghantaran (Peppol / IRAS / Laluan)',
      totalSubmissions: 'Jumlah Penghantaran',
      totalDocumentsTransmitted: 'Jumlah Dokumen Dihantar',
      totalDocuments: 'Jumlah Dokumen',
      successful: 'Berjaya',
      failed: 'Gagal',
      inProgress: 'Dalam Proses',
      errorsRejected: 'Ralat / Ditolak',
      notApplicable: 'T/B',
      channel: 'Saluran',
      delivery: 'Penghantaran',
      peppolTransmissionStatusReportTitle: 'Laporan Status Penghantaran Peppol',
      peppolMonthlyComplianceReportTitle: 'Laporan Pematuhan Bulanan Pihak Berkuasa Peppol',
      peppolReconciliationReportTitle: 'Laporan Penyesuaian Peppol',
      myPeppolTransmissionStatusReportTitle: 'Laporan Status Penghantaran Peppol Malaysia',
      myPeppolMonthlyComplianceReportTitle: 'Laporan Pematuhan Bulanan Pihak Berkuasa Peppol Malaysia',
      myPeppolReconciliationReportTitle: 'Laporan Penyesuaian Peppol Malaysia',
      reportingPeriod: 'Tempoh Pelaporan',
      fromMonthYear: 'Dari',
      toMonthYear: 'Hingga',
      lastTwelveMonths: '12 Bulan Lepas',
      invalidPeriodRange: 'Tempoh "Dari" mesti pada atau sebelum tempoh "Hingga".',
      month: 'Bulan',
      peppolTransmitted: 'Peppol Dihantar',
      successfulTransmissions: 'Penghantaran Berjaya',
      irasAccepted: 'IRAS Diterima',
      rejectedFailed: 'Ditolak / Gagal',
      as4Acknowledged: 'AS4 Diakui',
      as4Errored: 'AS4 Ralat',
      as4MessageId: 'ID Mesej AS4',
      generatedAt: 'Dijana Pada',
      downloadSubmissionCsv: 'Muat Turun CSV Penghantaran',
      downloadDocumentCsv: 'Muat Turun CSV Dokumen',
      routeC3C5: 'Peppol + IRAS (C3C5)',
      routeC5: 'IRAS Sahaja (C5)',
      outcome: 'Keputusan',
      transmitted: 'Dihantar',
      needsAttention: 'Penghantaran Memerlukan Perhatian',
      noGapsFound: 'Tiada jurang ditemui. Semua penghantaran berjaya dihantar.',
      totalCount: 'Jumlah Kiraan',
      summaryByStatus: 'RINGKASAN MENGIKUT STATUS',
      transactionCount: 'Kiraan Transaksi',
      documentByStatusReport: 'LAPORAN DOKUMEN MENGIKUT STATUS',
      noDataAvailable: 'Tiada data tersedia',
      filterByStatus: 'Tapis Mengikut Status',
      all: 'Semua',
      eDocumentDate: 'Tarikh eDokumen',
      eDocumentNumber: 'Nombor eDokumen',
      uniqueIdentifierNumber: 'Nombor Pengenalan Unik (UIN)',
      validationDate: 'Tarikh Pengesahan',
      buyerName: 'Nama Pembeli',
      sellerName: 'Nama Penjual',
      submissionDate: 'Tarikh Penghantaran',
      transactionReport: 'Laporan Transaksi',
      sortedBasedOnCreatedDate: '- Disusun Berdasarkan Tarikh Dicipta',
      sortedBasedOnValidatedDate: '- Disusun Berdasarkan Tarikh Disahkan',
      buyerId: 'ID Pembeli',
      myrEquivalent: 'Setara MYR',
      invoiceAmount: 'Jumlah Invois',
      crDrAdjusted: 'Pelarasan CR/DR',
      lhdnValidationDate: 'Tarikh Pengesahan LHDN',
      no: 'No',
      previous: 'Sebelumnya',
      next: 'Seterusnya',
      page: 'Halaman',
      rows: 'baris',
      reportBasedOnValidationDate: 'Laporan Berdasarkan Tarikh Pengesahan',
      reportBasedOnCreationDate: 'Laporan Berdasarkan Tarikh Penciptaan',
      monthAndYear: 'Bulan dan Tahun',
      month1: 'Januari',
      month2: 'Februari',
      month3: 'Mac',
      month4: 'April',
      month5: 'Mei',
      month6: 'Jun',
      month7: 'Julai',
      month8: 'Ogos',
      month9: 'September',
      month10: 'Oktober',
      month11: 'November',
      month12: 'Disember',
      totalEmails: 'Jumlah E-mel',
      success: 'Berjaya',
      failure: 'Gagal',
      resendEmail: 'Hantar Semula E-mel',
      srNo: 'No.',
      documentNumber: 'Nombor Dokumen',
      recipientEmail: 'E-mel Penerima',
      failedAt: 'Gagal Pada',
      resend: 'Hantar Semula',
      invoice: 'invois',
      proForma: 'pro-forma',
      creditNote: 'nota kredit',
      debitNote: 'nota debit',
      refundNote: 'nota bayaran balik',
      consolidated: 'disatukan',
      consolidatedInvoice: 'invois disatukan',
      selfBilledInvoice: 'invois bil sendiri',
      selfBilledCreditNote: 'nota kredit bil sendiri',
      selfBilledDebitNote: 'nota debit bil sendiri',
      selfBilledRefundNote: 'nota bayaran balik bil sendiri',
      open: 'terbuka',
      processing: 'memproses',
      paid: 'dibayar',
      close: 'tutup',
      cancelled: 'dibatalkan',
      name: 'NAMA',
      numberOfCustomer: 'BILANGAN PELANGGAN',
      action: 'TINDAKAN',
      newCustomerGroup: 'Kumpulan Pelanggan Baharu',
      customer: 'PELANGGAN',
      allDocuments: 'Semua Dokumen',
      receivables: 'Belum Terima (AR)',
      payables: 'Belum Bayar (AP)',
      totalReceivables: 'Jumlah Belum Terima (AR)',
      totalPayables: 'Jumlah Belum Bayar (AP)',
      netPosition: 'Kedudukan Bersih',
      netReceivable: 'Belum Terima Bersih',
      netPayable: 'Belum Bayar Bersih',
      documents: 'Dokumen',
      selectIssuedDateRange: 'PILIH JULAT TARIKH DIKELUARKAN',
      filterOptions: 'PILIHAN TAPISAN',
      category: 'Kategori',
      allCategories: 'Semua Kategori',
      arRegular: 'AR Biasa',
      arSelfBilled: 'AR Bil Sendiri',
      apReceived: 'AP Diterima',
      status: 'Status',
      allStatuses: 'Semua Status',
      documentType: 'Jenis Dokumen',
      allTypes: 'Semua Jenis',
      counterparty: 'Pihak Lawan',
      searchCounterparty: 'Cari pihak lawan...',
      currency: 'Mata Wang',
      allCurrencies: 'Semua Mata Wang',
      unpaidOnly: 'Belum Dibayar Sahaja (AR)',
      overdueOnly: 'Tertunggak Sahaja (AR)',
      hasEInvoice: 'Ada E-Invois',
      clearFilters: 'Kosongkan Tapisan',
      documentCount: 'Kiraan Dokumen',
      totalAmount: 'Jumlah Keseluruhan',
      documentLedgerReport: 'Laporan Lejar Dokumen',
      exportExcel: 'Eksport Excel',
      exportPdf: 'Eksport PDF',
      no: 'No',
      direction: 'Arah',
      documentNo: 'No Dokumen',
      type: 'Jenis',
      counterpartyTin: 'TIN Pihak Lawan',
      issuedDate: 'Tarikh Dikeluarkan',
      dueReceivedDate: 'Tarikh Tamat/Diterima',
      exclTax: 'Tanpa Cukai',
      tax: 'Cukai',
      eInvoiceStatus: 'Status E-Invois',
      lhdnUuid: 'UUID LHDN',
      accumulatingTotal: 'Jumlah Terkumpul',
      thisYear: 'Tahun Ini',
      showing: 'Menunjukkan',
      to: 'Hingga:',
      of: 'daripada',
      entries: 'entri',
      rowsPerPage: 'Baris setiap halaman',
      documentLedger: 'Lejar Dokumen - Paparan bersatu semua dokumen AR (Belum Terima) dan AP (Belum Bayar)',
      recordPerPage: 'Rekod Setiap Halaman',
      bulkImport: 'Import Pukal',
      submitForValidation: 'Hantar Untuk Pengesahan',
      consolidateInvoices: 'Satukan Invois',
      exportCsvReport: 'Eksport Laporan CSV',
      exportSelected: 'Eksport Dipilih',
      docNo: 'No Dok',
      dueAt: 'Tarikh Tamat',
      date: 'Tarikh',
      selectPdfTemplate: 'PILIH TEMPLAT PDF',
      general: 'Umum',
      documentTypeRequired: 'Jenis Dokumen *',
      printType: 'Jenis Cetak',
      customiseTemplate: 'Sesuaikan Templat',
      pageMargin: 'Jidar Halaman',
      leftMargin: 'Jidar Kiri *',
      topMargin: 'Jidar Atas *',
      rightMargin: 'Jidar Kanan *',
      bottomMargin: 'Jidar Bawah *',
      filter: 'Tapis',
      customerId: 'ID PELANGGAN',
      customerName: 'NAMA PELANGGAN',
      parentCustomer: 'PELANGGAN INDUK',
      email: 'E-MEL',
      phone: 'TELEFON',
      reference1: 'RUJUKAN 1',
      reference2: 'RUJUKAN 2',
      reference3: 'RUJUKAN 3',
      dueDateFrom: 'TARIKH TAMAT DARI',
      dueDateTo: 'TARIKH TAMAT HINGGA',
      creationDateFrom: 'TARIKH DICIPTA DARI',
      creationDateTo: 'TARIKH DICIPTA HINGGA',
      updateDateFrom: 'TARIKH KEMASKINI DARI',
      updateDateTo: 'TARIKH KEMASKINI HINGGA',
      showPendingEInvoice: 'TUNJUK PENCIPTAAN E-INVOIS TERTANGGUH SAHAJA',
      amount: 'JUMLAH',
      amountFrom: 'JUMLAH DARI',
      amountTo: 'JUMLAH HINGGA',
      transactionType: 'JENIS TRANSAKSI',
      paymentChannel: 'SALURAN PEMBAYARAN',
      submissionDateFrom: 'TARIKH PENGHANTARAN DARI',
      submissionDateTo: 'TARIKH PENGHANTARAN HINGGA',
      lhdnStatus: 'STATUS LHDN',
      submissionId: 'ID PENGHANTARAN',
      uuid: 'UUID',
      buyerTin: 'TIN PEMBELI',
      buyerName: 'NAMA PEMBELI',
      supplierTin: 'TIN PEMBEKAL',
      supplierName: 'NAMA PEMBEKAL',
      fileName: 'NAMA FAIL',
      fileType: 'JENIS FAIL',
      uploadDateFrom: 'TARIKH MUAT NAIK DARI',
      uploadDateTo: 'TARIKH MUAT NAIK HINGGA',
      invoiceNo: 'NO INVOIS',
      id: 'ID',
      type: 'JENIS',
      types: 'JENIS',
      transactionId: 'ID TRANSAKSI',
      dateFrom: 'TARIKH DARI',
      dateTo: 'TARIKH HINGGA',
      exported: 'DIEKSPORT',
      eInvoiceId: 'ID E-Invois',
      sgPeppolStatus: 'Status SG Peppol',
      sgUen: 'UEN SG (InvoiceNow)',
      sgUenPlaceholder: 'cth. 202200001A',
      irasStatus: 'Status IRAS',
      destination: 'Destinasi',
      acknowledgementId: 'ID Pengakuan',
      buyerResponse: 'Maklum Balas Pembeli',
      sent: 'Dihantar',
      completed: 'Selesai',
      customerSupplier: 'Pelanggan / Pembekal',
      createdAt: 'Dicipta Pada',
      submittedAt: 'Dihantar Pada',
      updatedAt: 'Dikemaskini Pada',
      submitToLhdn: 'Hantar ke LHDN',
      bulkPdfDownload: 'Muat Turun PDF secara Pukal',
      refreshPage: 'Segar Semula',
      submitToSgPeppol: 'Hantar',
      viewDetails: 'Lihat Butiran',
      download: 'Muat Turun',
      cancel: 'Batal',
      void: 'Batal',
      na: 'T/B',
      applyInvoice: 'Guna Invois',
      supplier: 'Pembekal',
      bulkDelete: 'Padam Pukal',
      appliedToInvoice: 'Diguna pada Invois',
      description: 'Penerangan',
      internalId: 'ID Dalaman',
      transactionId: 'ID Transaksi',
      export: 'Eksport',
      refresh: 'Muat Semula',
      completedAt: 'Selesai Pada',
      emailFrom: 'E-mel Dari',
      emailTo: 'E-mel Kepada',
      usersRoleManagement: 'Pengurusan Peranan Pengguna',
      searchUsers: 'Cari pengguna mengikut nama atau e-mel...',
      addNewUser: 'Tambah Pengguna Baharu',
      userName: 'Nama Pengguna',
      role: 'Peranan',
      actions: 'Tindakan',
      setUserInactive: 'Tetapkan pengguna tidak aktif',
      sgPeppolSubmissions: 'Penghantaran SG Peppol',
      docs: 'Dok',
      route: 'Laluan',
      peppol: 'Peppol',
      iras: 'IRAS',
      basic: 'Asas',
      groupName: 'Nama Kumpulan',
      customers: 'Pelanggan',
      downloadEInvoice: 'MUAT TURUN E-INVOIS',
      downloading: 'MEMUAT TURUN...',
      viewPayload: 'Lihat Muatan',
      overview: 'Gambaran Keseluruhan',
      invoiceNo: 'No Invois',
      irbmNo: 'No IRBM',
      eInvoiceType: 'Jenis E-invois',
      eInvoiceVersion: 'Versi E-invois',
      exchangeRate: 'Kadar Pertukaran',
      exportInvoices: 'EKSPORT INVOIS',
      registrationTypeNo: 'Jenis Pendaftaran / No',
      save: 'Simpan',
      close: 'Tutup',
      back: 'Kembali',
      searchByTransactionId: 'Cari mengikut ID Transaksi',
      selectStatus: 'Pilih status',
      selectRoute: 'Pilih laluan',
      selectDocumentType: 'Pilih jenis dokumen',
      paymentChannelSetting: 'Tetapan Saluran Pembayaran',
      newPaymentChannel: 'Saluran Pembayaran Baharu',
      provider: 'Penyedia',
      customerGroup: 'Kumpulan Pelanggan',
      emailSmtpSetting: 'Tetapan SMTP E-mel',
      newSmtpSetting: 'Tetapan SMTP Baharu',
      host: 'Hos',
      port: 'Port',
      user: 'Pengguna',
      tenantInfo: 'Maklumat Penyewa',
      updateTenantInfo: 'Kemaskini Maklumat Penyewa',
      tin: 'TIN',
      registrationNo: 'No Pendaftaran',
      sst: 'SST',
      contactNo: 'No Hubungan',
      mailingAutomationSetting: 'Tetapan Automasi Mel',
      updateMailingAutomation: 'Kemaskini Automasi Mel',
      sendEmailUponCreation: 'Hantar E-mel Selepas Dicipta',
      sendEmailUponValidated: 'Hantar E-mel Selepas Disahkan',
      sendEmailUponAdhocImported: 'Hantar E-mel Selepas Import Adhoc',
      sendEmailUponAdhocValidated: 'Hantar E-mel Selepas Pengesahan Adhoc',
      enabledCustomerGroup: 'Kumpulan Pelanggan Diaktifkan',
      enabledDocumentType: 'Jenis Dokumen Diaktifkan',
      enabled: 'Diaktifkan',
      disabled: 'Dinyahaktifkan',
      einvoiceAutomationSetting: 'Tetapan Automasi E-Invois',
      updateEinvoiceAutomation: 'Kemaskini Automasi E-Invois',
      createEinvoiceUponImported: 'Cipta E-Invois Selepas Import',
      submitEinvoiceUponValidated: 'Hantar E-Invois Selepas Disahkan',
      otpSetting: 'Tetapan OTP',
      updateOtpSetting: 'Kemaskini Tetapan OTP',
      isTenantOtpEnabled: 'Adakah OTP Penyewa Diaktifkan',
      isPayeeOtpEnabled: 'Adakah OTP Penerima Diaktifkan',
      sgPeppolSetting: 'Tetapan SG Peppol (InvoiceNow)',
      configureSgPeppol: 'Konfigurasi SG Peppol',
      singaporeUen: 'UEN Singapura',
      peppolId: 'ID Peppol',
      sgUen: 'UEN SG (InvoiceNow)',
      sgUenPlaceholder: 'cth. 202200001A',
      gstRegistrationNo: 'No Pendaftaran GST',
      irasC5UserId: 'ID Pengguna IRAS C5',
      verificationStatus: 'Status Pengesahan',
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      verified: 'Disahkan',
      pending: 'Tertangguh',
      logoImage: 'Imej Logo',
      letterHeadImage: 'Imej Kepala Surat',
      footerImage: 'Imej Pengaki',
      update: 'Kemaskini',
      pdfTemplates: 'Templat PDF',
      addTemplate: 'Tambah Templat',
      templateName: 'Nama Templat',
      customised: 'Disesuaikan',
      uploadFile: 'Muat Naik Fail',
      importErrors: 'Ralat Import',
      previewData: 'Pratonton Data',
      clearFile: 'Kosongkan Fail',
      download: 'Muat Turun',
      downloadCreditNote: 'MUAT TURUN NOTA KREDIT',
      downloadDebitNote: 'MUAT TURUN NOTA DEBIT',
      downloadInvoice: 'MUAT TURUN INVOIS',
      unitCost: 'Kos Unit',
      appliedAmount: 'Jumlah Diguna',
      appliedAt: 'Diguna Pada',
      appliedTo: 'Diguna Kepada',
      lhdnUuid: 'UUID LHDN',
      searchTin: 'Cari TIN',
      sstNumber: 'Nombor SST',
      emailForLhdn: 'Alamat E-mel untuk LHDN',
      contactEmailAddress: 'Alamat E-mel Hubungan',
      paymentTerm: 'Terma Pembayaran',
      paymentTermType: 'Jenis Terma Pembayaran',
      netPaymentTermDay: 'Hari Terma Pembayaran Bersih',
      address: 'Alamat',
      addressNum: 'No Alamat',
      address1: 'Alamat 1',
      address2: 'Alamat 2',
      postalCode: 'Poskod',
      city: 'Bandar',
      state: 'Negeri',
      country: 'Negara',
      others: 'Lain-lain',
      draftEmail: 'Draf E-mel',
      draftMessage: 'Draf Mesej',
      sendToPeppol: 'Hantar ke Peppol',
      peppolData: 'Data Peppol',
      senderId: 'ID Penghantar',
      receiverId: 'ID Penerima',
      codeNumber: 'Nombor Kod',
      customerTin: 'TIN Pelanggan',
      userInformation: 'Maklumat Pengguna',
      companyRegistrationNo: 'No Pendaftaran Syarikat',
      tourismRegistrationNo: 'No Pendaftaran Pelancongan',
      msicCode: 'Kod MSIC',
      businessActivityDescription: 'Penerangan Aktiviti Perniagaan',
      activateIdleTimeOut: 'Aktifkan Tamat Masa Melahu',
      maxUserCount: 'Bilangan pengguna maksimum yang dibenarkan',
      addressLine1: 'Baris Alamat 1',
      addressLine2: 'Baris Alamat 2',
      addressPostal: 'Poskod Alamat',
      addressCity: 'Bandar Alamat',
      supportEmailAddress: 'Alamat E-mel Sokongan',
      digitalSignature: 'Tandatangan Digital',
      supplierBankNumber: 'Nombor Bank Pembekal',
      fractionDigits: 'Digit Pecahan',
      businessStationery: 'Alat Tulis Perniagaan',
      letterHead: 'Kepala Surat',
      footer: 'Pengaki',
      note: 'Nota',
      submit: 'Hantar',
      roleManagement: 'Pengurusan Peranan',
      searchRoles: 'Cari peranan...',
      roleName: 'Nama Peranan',
      permissions: 'Kebenaran',
      userType: 'Jenis Pengguna',
      password: 'Kata Laluan',
      emailSmtp: 'SMTP E-mel',
      setCustomerAccess: 'Tetapkan Akses Pelanggan',
      customTemplate: 'Templat Tersuai',
      standardTemplates: 'Templat Standard',
      header: 'pengepala',
      body: 'isi',
      notActivated: 'Tidak Diaktifkan',
      sgPeppolConfiguration: 'Konfigurasi Peppol Singapura (InvoiceNow)',
      accountInfo: 'Maklumat Akaun',
      whatsappMessage: 'Mesej WhatsApp',
      paidAt: 'Dibayar Pada',
      dueDate: 'Tarikh Tamat',
      invoiceDiscount: 'Diskaun Invois',
      totalDiscount: 'Jumlah Diskaun',
      totalTax: 'Jumlah Cukai',
      balance: 'Baki',
      remarks: 'Catatan',
      invoiceItems: 'Item Invois',
      eInvoiceSubmittedDate: 'Tarikh Penghantaran E-invois',
      eInvoiceValidationUrl: 'URL Pengesahan E-invois',
      eInvoiceValidatedDate: 'Tarikh Pengesahan E-invois',
      expandSupplierDetails: 'Kembangkan Butiran Pembekal',
      hideSupplierDetails: 'Sembunyikan Butiran Pembekal',
      expandBuyerDetails: 'Kembangkan Butiran Pembeli',
      hideBuyerDetails: 'Sembunyikan Butiran Pembeli',
      expandRecipientDetails: 'Kembangkan Butiran Penerima',
      hideRecipientDetails: 'Sembunyikan Butiran Penerima',
      expandTaxDetails: 'Kembangkan Butiran Cukai',
      hideTaxDetails: 'Sembunyikan Butiran Cukai',
      expandCustomFormDetails: 'Kembangkan Butiran Borang Kastam',
      hideCustomFormDetails: 'Sembunyikan Butiran Borang Kastam',
      showTaxDetails: 'Tunjuk butiran cukai',
      hideTaxDetailsTooltip: 'Sembunyikan butiran cukai',
      supplier: 'Pembekal',
      buyer: 'Pembeli',
      recipient: 'Penerima',
      editItem: 'Edit Item',
      edit: 'Edit',
      supplierName: 'Nama Pembekal *',
      supplierTin: 'TIN Pembekal *',
      supplierTourismRegistration: 'Pendaftaran Pelancongan Pembekal',
      supplierMsicCode: 'Kod Klasifikasi Industri Standard Malaysia (MSIC) Pembekal *',
      supplierBusinessActivity: 'Penerangan Aktiviti Perniagaan Pembekal *',
      supplierEmail: 'E-mel Pembekal',
      supplierAddressNum: 'No Alamat Pembekal *',
      supplierAddressLine1: 'Baris Alamat Pembekal 1',
      supplierAddressLine2: 'Baris Alamat Pembekal 2',
      supplierAddressPostal: 'Poskod Alamat Pembekal *',
      supplierAddressCity: 'Bandar Alamat Pembekal *',
      supplierContactNumber: 'No Hubungan Pembekal *',
      supplierState: 'Negeri Pembekal *',
      supplierCountry: 'Negara Pembekal *',
      supplierSst: 'SST Pembekal',
      buyerName: 'Nama Pembeli *',
      buyerTin: 'TIN Pembeli *',
      buyerEmail: 'E-mel Pembeli',
      buyerAddressNum: 'No Alamat Pembeli *',
      buyerAddressLine1: 'Baris Alamat Pembeli 1',
      buyerAddressLine2: 'Baris Alamat Pembeli 2',
      buyerAddressPostal: 'Poskod Alamat Pembeli *',
      buyerAddressCity: 'Bandar Alamat Pembeli *',
      buyerContactNumber: 'No Hubungan Pembeli *',
      buyerAddressState: 'Negeri Alamat Pembeli *',
      buyerCountry: 'Negara Pembeli *',
      buyerSst: 'SST Pembeli',
      recipientName: 'Nama Penerima',
      recipientTin: 'TIN Penerima',
      recipientRegistration: 'Pendaftaran Penerima',
      recipientAddressNum: 'No Alamat Penerima',
      recipientAddressLine1: 'Baris Alamat Penerima 1',
      recipientAddressLine2: 'Baris Alamat Penerima 2',
      recipientAddressPostal: 'Poskod Alamat Penerima',
      recipientAddressCity: 'Bandar Alamat Penerima',
      recipientAddressState: 'Negeri Alamat Penerima',
      recipientAddressCountry: 'Negara Alamat Penerima',
      taxInfo: 'Maklumat Cukai',
      taxExemptionReason: 'Sebab Pengecualian Cukai',
      totalTaxAmountPerTaxType: 'Jumlah Cukai Setiap Jenis Cukai',
      totalTaxableAmountPerTaxType: 'Jumlah Boleh Cukai Setiap Jenis Cukai',
      totalExemptionAmount: 'Jumlah Pengecualian',
      customsFormDetails: 'Butiran Borang Kastam',
      customForm: 'Borang Kastam',
      customsReferenceNum: 'No Rujukan Kastam',
      customsReferenceNum2: 'No Rujukan Kastam 2',
      incoterms: 'Incoterms',
      irbmInfo: 'Maklumat IRBM',
      missingItems: 'Item Hilang',
      submissionErrors: 'Ralat Penghantaran',
      cancellationResponse: 'Respons Pembatalan',
      cancellationReason: 'Sebab Pembatalan',
      editLineItem: 'EDIT ITEM BARIS',
      classification: 'Klasifikasi',
      uom: 'UOM',
      taxExemptionAmount: 'Jumlah Pengecualian Cukai',
      taxBreakdown: 'Pecahan Cukai',
      taxTypeHeader: 'Jenis Cukai',
      taxRate: 'Kadar Cukai %',
      discountRate: 'Kadar Diskaun',
      lineTotal: 'Jumlah Baris',
      taxCategory: 'Kategori Cukai',
      unit: 'Unit',
      id: 'ID',
      taxableAmount: 'Jumlah Boleh Cukai',
      taxAmount: 'Jumlah Cukai',
      reason: 'Sebab',
      invoiceLineItems: 'Item Baris Invois',
      downloadPayload: 'MUAT TURUN MUATAN',
      searchTin: 'Cari TIN',
      bulkImport: 'Import Pukal',
      bulkApply: 'Guna Pukal',
      bulkImportCustomers: 'Import pukal pelanggan anda ke Platform Invois Pintar.',
      bulkImportConsolidatedInvoices: 'Import pukal invois disatukan anda ke Platform Invois Pintar.',
      bulkImportProForma: 'Import pukal invois Pro-Forma anda ke Platform Invois Pintar.',
      bulkImportSelfBilled: 'Import pukal invois bil sendiri anda ke Platform Invois Pintar.',
      bulkImportDebitNote: 'Import pukal Nota Debit anda ke Platform Invois Pintar.',
      bulkImportRefundNotes: 'Import pukal Nota Bayaran Balik anda ke Platform Invois Pintar.',
      bulkImportCreditNotes: 'Import pukal Nota Kredit anda ke Platform Invois Pintar.',
      bulkImportCustomersToGroup: 'Import pukal pelanggan anda ke Kumpulan Pelanggan ini.',
      customer: 'Pelanggan',
      overview: 'Gambaran Keseluruhan',
      paymentFrom: 'Pembayaran Dari',
      applyPaymentTo: 'Guna Pembayaran Kepada',
      uploadAttachments: 'Muat Naik Lampiran',
      chequeInfo: 'Maklumat Cek',
      onlinePaymentInfo: 'Maklumat Pembayaran Dalam Talian',
      paymentChannel: 'Saluran Pembayaran',
      setCustomerAccess: 'Tetapkan Akses Pelanggan',
      basic: 'Asas',
      items: 'Item',
      itemsCount: 'Item',
      item: 'Item',
      quantity: 'Kuantiti',
      tax: 'Cukai',
      discount: 'Diskaun',
      subtotal: 'Jumlah Kecil',
      payments: 'Pembayaran',
      proForma: 'Pro Forma',
      creditNotes: 'Nota Kredit',
      debitNotes: 'Nota Debit',
      refundNotes: 'Nota Bayaran Balik',
      attachments: 'Lampiran',
      file: 'Fail',
      phone: 'Telefon',
      emailAddress: 'Alamat E-mel',
      appliedToInvoice: 'Diguna pada Invois',
      standard: 'Standard',
      reference1: 'Rujukan 1',
      reference2: 'Rujukan 2',
      reference3: 'Rujukan 3',
      verify: 'Sahkan',
      currencyCode: 'Kod Mata Wang',
      registrationType: 'Jenis Pendaftaran',
      updateTenantInfo: 'KEMASKINI MAKLUMAT PENYEWA',
      minFractionDigitsPrice: 'Digit Pecahan Minimum Harga',
      maxFractionDigitsPrice: 'Digit Pecahan Maksimum Harga',
      minFractionDigitsQuantity: 'Digit Pecahan Minimum Kuantiti',
      maxFractionDigitsQuantity: 'Digit Pecahan Maksimum Kuantiti',
      minFractionDigitsAmount: 'Digit Pecahan Minimum Jumlah',
      maxFractionDigitsAmount: 'Digit Pecahan Maksimum Jumlah',
      userDefinedDateFormat: 'Format Tarikh Ditetapkan Pengguna',
      rightMargin: 'Jidar Kanan',
      bottomMargin: 'Jidar Bawah',
      select: 'PILIH',
      preview: 'Pratonton',
      upload: 'Muat Naik',
      processing: 'Memproses...',
      currency: 'Mata Wang',
      amount: 'Jumlah',
      bulkImportInvoices: 'Import pukal invois anda ke Platform Invois Pintar.',
    },

    // Common Actions
    actions: {
      add: 'Tambah',
      addNew: 'Tambah Baharu',
      edit: 'Edit',
      delete: 'Padam',
      save: 'Simpan',
      cancel: 'Batal',
      confirm: 'Sahkan',
      search: 'Cari',
      filter: 'Tapis',
      export: 'Eksport',
      clear: 'Kosongkan',
      import: 'Import',
      download: 'Muat Turun',
      upload: 'Muat Naik',
      view: 'Lihat',
      close: 'Tutup',
      back: 'Kembali',
      next: 'Seterusnya',
      previous: 'Sebelumnya',
      submit: 'Hantar',
      reset: 'Set Semula',
      select: 'Pilih',
      selectAll: 'Pilih Semua',
      copy: 'Salin',
      print: 'Cetak',
      refresh: 'Muat Semula',
      update: 'Kemaskini',
      create: 'Cipta',
      send: 'Hantar',
      resend: 'Hantar Semula',
      approve: 'Luluskan',
      reject: 'Tolak',
      continue: 'Teruskan',
    },

    // Common Labels
    labels: {
      name: 'Nama',
      email: 'E-mel',
      phone: 'Telefon',
      address: 'Alamat',
      date: 'Tarikh',
      time: 'Masa',
      status: 'Status',
      type: 'Jenis',
      description: 'Penerangan',
      amount: 'Jumlah',
      total: 'Jumlah',
      subtotal: 'Jumlah Kecil',
      tax: 'Cukai',
      discount: 'Diskaun',
      quantity: 'Kuantiti',
      unitPrice: 'Harga Unit',
      unitCost: 'Kos Unit',
      price: 'Harga',
      item: 'Item',
      items: 'Item',
      customer: 'Pelanggan',
      supplier: 'Pembekal',
      invoice: 'Invois',
      invoiceNo: 'No Invois',
      invoiceNumber: 'Nombor Invois',
      documentNo: 'No Dokumen',
      reference: 'Rujukan',
      notes: 'Nota',
      remarks: 'Catatan',
      currency: 'Mata Wang',
      paymentMethod: 'Kaedah Pembayaran',
      paymentStatus: 'Status Pembayaran',
      dueDate: 'Tarikh Tamat',
      issueDate: 'Tarikh Keluaran',
      createdAt: 'Dicipta Pada',
      updatedAt: 'Dikemaskini Pada',
      createdBy: 'Dicipta Oleh',
      overview: 'Gambaran Keseluruhan',
      details: 'Butiran',
      summary: 'Ringkasan',
      history: 'Sejarah',
      all: 'Semua',
      active: 'Aktif',
      inactive: 'Tidak Aktif',
      pending: 'Tertangguh',
      approved: 'Diluluskan',
      rejected: 'Ditolak',
      draft: 'Draf',
      sent: 'Dihantar',
      paid: 'Dibayar',
      unpaid: 'Belum Dibayar',
      overdue: 'Tertunggak',
      cancelled: 'Dibatalkan',
      completed: 'Selesai',
      processing: 'Memproses',
      failed: 'Gagal',
      success: 'Berjaya',
    },

    // Authentication
    auth: {
      login: 'Log Masuk',
      logout: 'Log Keluar',
      register: 'Daftar',
      password: 'Kata Laluan',
      confirmPassword: 'Sahkan Kata Laluan',
      newPassword: 'Kata Laluan Baharu',
      currentPassword: 'Kata Laluan Semasa',
      forgotPassword: 'Lupa Kata Laluan?',
      resetPassword: 'Set Semula Kata Laluan',
      rememberMe: 'Ingat Saya',
      showPassword: 'Tunjuk kata laluan',
      emailAndPassword: 'E-mel & Kata Laluan',
      ssoLogin: 'Log Masuk SSO',
      validateOtp: 'Sahkan OTP',
      resendOtp: 'Hantar Semula OTP',
      otp: 'OTP',
      loggingIn: 'Log masuk...',
      loginWithSso: 'Log Masuk dengan SSO',
      welcomeBack: 'Selamat kembali, sila log masuk ke akaun anda.',
      recoverPassword: 'Pulihkan kata laluan anda',
      recoverPasswordDesc: 'Sila masukkan alamat e-mel anda dan kami akan menghantar arahan untuk set semula kata laluan.',
      resetPasswordDesc: 'Sila masukkan kata laluan baharu anda.',
      backToLogin: 'Kembali Ke Log Masuk',
      goBackToLogin: 'Kembali Ke Log Masuk',
      forgotPasswordMessage: 'Terima kasih, sila semak e-mel anda untuk arahan set semula kata laluan.',
      samePassword: '"Kata Laluan" mesti sama dengan "Sahkan Kata Laluan"',
      chooseLoginMethod: 'Pilih kaedah log masuk anda',
      ssoRedirectInfo: 'Anda akan dialihkan ke halaman log masuk organisasi anda untuk pengesahan selamat.',
      ssoAccountDetected: 'E-mel ini didaftarkan untuk pengesahan SSO. Sila gunakan pilihan log masuk SSO.',
      alreadyLoggedIn: 'Sudah log masuk',
      redirectingToDashboard: 'Mengalih ke Papan Pemuka...',
      ssoNotAvailable: 'SSO tidak tersedia untuk akaun ini',
      accountNotFound: 'Akaun tidak dijumpai. Hubungi pentadbir anda.',
      loginFailed: 'Log masuk gagal. Sila cuba lagi.',
      otpRequired: 'OTP diperlukan.',
      incorrectOtp: 'OTP tidak betul. Sila cuba lagi.',
      otpValidationFailed: 'Pengesahan OTP gagal. Sila cuba lagi.',
      unableToResendOtp: 'Tidak dapat menghantar semula OTP. Sila cuba lagi.',
      ssoAuthFailed: 'Pengesahan SSO gagal. Sila cuba lagi.',
      fillRequiredFields: 'Sila isi semua medan yang diperlukan dengan betul.',
    },

    // Form Fields
    form: {
      required: 'Medan ini diperlukan',
      invalidEmail: 'Sila masukkan alamat e-mel yang sah',
      invalidPhone: 'Sila masukkan nombor telefon yang sah',
      minLength: 'Minimum {min} aksara diperlukan',
      maxLength: 'Maksimum {max} aksara dibenarkan',
      passwordMismatch: 'Kata laluan tidak sepadan',
      selectOption: 'Sila pilih pilihan',
      enterValue: 'Sila masukkan nilai',
    },

    // Table Headers
    table: {
      item: 'Item',
      description: 'Penerangan',
      quantity: 'Kuantiti',
      unitCost: 'Kos Unit',
      tax: 'Cukai',
      discount: 'Diskaun',
      subtotal: 'Jumlah Kecil',
      total: 'Jumlah',
      transactionId: 'ID Transaksi',
      type: 'Jenis',
      status: 'Status',
      date: 'Tarikh',
      docNo: 'No Dok',
      action: 'Tindakan',
      actions: 'Tindakan',
      noDataAvailable: 'Tiada data tersedia',
      showingEntries: 'Menunjukkan {from} hingga {to} daripada {total} entri',
    },

    // Messages
    messages: {
      confirmDelete: 'Sahkan untuk Padam?',
      confirmDeleteMessage: 'Adakah anda pasti mahu memadam item ini?',
      successDeleted: 'Berjaya Dipadam',
      successDeletedMessage: 'Item telah berjaya dipadam',
      successSaved: 'Berjaya Disimpan',
      successSavedMessage: 'Perubahan telah berjaya disimpan',
      successCreated: 'Berjaya Dicipta',
      successCreatedMessage: 'Item telah berjaya dicipta',
      successUpdated: 'Berjaya Dikemaskini',
      successUpdatedMessage: 'Item telah berjaya dikemaskini',
      errorOccurred: 'Ralat berlaku',
      somethingWentWrong: 'Sesuatu Tidak Kena',
      pleaseWait: 'Sila tunggu...',
      loading: 'Memuatkan...',
      noResults: 'Tiada keputusan dijumpai',
      noData: 'Tiada data',
      confirmAction: 'Sahkan Tindakan',
      areYouSure: 'Adakah anda pasti?',
      operationSuccess: 'Operasi berjaya',
      operationFailed: 'Operasi gagal',
    },

    // Customer Module
    tenantCustomer: {
      message: {
        ConfirmDelete: 'Sahkan untuk Padam?',
        ConfirmDeleteMessage: 'Adakah anda pasti mahu memadam pelanggan "%{item}" ?',
        SuccessDeleted: 'Pelanggan telah Dipadam',
        SuccessDeletedMessage: 'Pelanggan yang dipilih telah berjaya dipadam',
        FailedTitle: 'Sesuatu Tidak Kena',
      },
    },

    // Invoice Module
    invoice: {
      downloadInvoice: 'Muat Turun Invois',
      invoiceDetails: 'Butiran Invois',
      lineItems: 'Item Baris',
      paymentHistory: 'Sejarah Pembayaran',
      relatedDocuments: 'Dokumen Berkaitan',
      message: {
        ConfirmDelete: 'Sahkan untuk Padam?',
        ConfirmDeleteMessage: 'Adakah anda pasti mahu memadam invois "%{item}" ?',
        SuccessDeleted: 'Invois telah Dipadam',
        SuccessDeletedMessage: 'Invois yang dipilih telah berjaya dipadam',
        FailedTitle: 'Sesuatu Tidak Kena',
      },
    },

    // Order Module
    order: {
      downloadOrder: 'Muat Turun Pesanan',
      orderNo: 'No Pesanan',
      orderItems: 'Item Pesanan',
      irspAction: 'Tindakan IRSP',
      irspStatus: 'Status IRSP',
      irspOrderAction: 'Tindakan Pesanan IRSP',
      irspStatusPanel: 'Status Penyerahan IRSP',
      submitToIrsp: 'Hantar',
      convertToInvoice: 'Tukar ke Invois',
      convert: 'Tukar',
      refreshStatus: 'Muat Semula Status',
      referenceDocNo: 'No Dokumen Rujukan',
      peppolId: 'ID Peppol',
      supplier: 'Pembekal',
      buyer: 'Pembeli',
      registration: 'Pendaftaran',
      tin: 'TIN',
      taxType: 'Jenis Cukai',
      paymentTerms: 'Terma Pembayaran',
      documentType: 'Jenis Dokumen',
      overallStatus: 'Status Keseluruhan',
      destination: 'Destinasi',
      irasStatus: 'Status IRAS',
      peppolStatus: 'Status Peppol',
      acknowledgementId: 'ID Pengakuan',
      buyerResponse: 'Maklum Balas Pembeli',
      submittedAt: 'Dihantar Pada',
      statusMessage: 'Mesej Status',
      submissionHistory: 'Sejarah Penyerahan',
      noIrspSubmission: 'Tiada penyerahan IRSP ditemui untuk pesanan ini.',
      totalOrders: 'Jumlah Pesanan',
      openOrders: 'Pesanan Terbuka',
      sellerResponses: 'Respons Pesanan Penjual',
      response: 'Respons',
      message: {
        confirmDelete: 'Sahkan untuk Padam?',
        confirmDeleteMessage: 'Adakah anda pasti mahu memadam pesanan "%{item}" ?',
        deleteSuccessTitle: 'Pesanan telah Dipadam',
        deleteSuccessMessage: 'Pesanan yang dipilih telah berjaya dipadam.',
        failedTitle: 'Sesuatu Tidak Kena',
        noValidDocs: 'Tiada Dokumen Sah',
        noValidDocsMessage: 'Pesanan yang dipilih telah dihantar ke IRSP atau tidak boleh dihantar.',
        irspSubmitSuccess: 'Penyerahan IRSP Dibuat',
        irspSubmitFailed: 'Penyerahan IRSP Gagal',
        statusRefreshed: 'Status Dimuat Semula',
        convertSuccess: 'Penukaran Berjaya',
        enterInvoiceDocNo: 'Masukkan No Dokumen Invois untuk invois baharu:',
      },
    },

    // Payment Channel
    paymentChannel: {
      message: {
        ConfirmDelete: 'Sahkan untuk Padam?',
        ConfirmDeleteMessage: 'Adakah anda pasti mahu memadam saluran pembayaran "%{item}" ?',
        SuccessDeleted: 'Saluran Pembayaran telah Dipadam',
        SuccessDeletedMessage: 'Saluran pembayaran yang dipilih telah berjaya dipadam',
        FailedTitle: 'Sesuatu Tidak Kena',
      },
    },

    // PDF Setting
    pdfSetting: {
      message: {
        ConfirmDelete: 'Sahkan untuk Padam?',
        ConfirmDeleteMessage: 'Adakah anda pasti mahu memadam Tetapan PDF" ?',
        SuccessDeleted: 'Tetapan PDF telah Dipadam',
        SuccessDeletedMessage: 'Tetapan PDF yang dipilih telah berjaya dipadam',
        FailedTitle: 'Sesuatu Tidak Kena',
      },
    },

    // Legacy keys for backward compatibility
    Dashboard: 'Papan Pemuka',
    Resources: 'Sumber',
    Users: 'Pengguna',
    Skills: 'Kemahiran',
    ServiceTypes: 'Jenis Perkhidmatan',
    ServicePackages: 'Pakej Perkhidmatan',
    ServiceGroup: 'Kumpulan Perkhidmatan',
    ServiceProviders: 'Penyedia Perkhidmatan',
    ServiceTickets: 'Tiket Perkhidmatan',
    Feedbacks: 'Maklum Balas',
    eCommerce: 'e-Dagang',
    Dealers: 'Peniaga',
    Roles: 'Peranan',
    Apps: 'Aplikasi',
    Todo: 'Tugasan',
    Chat: 'Sembang',
    Email: 'E-mel',
    Calendar: 'Kalendar',
    FullCalendar: 'Kalendar Penuh',
    SimpleCalendar: 'Kalendar Mudah',
    Shop: 'Kedai',
    ItemDetails: 'Butiran Item',
    Cart: 'Troli',
    WishList: 'Senarai Hajat',
    Checkout: 'Daftar Keluar',
    UI: 'UI',
    DataList: 'Senarai Data',
    ListView: 'Paparan Senarai',
    ThumbView: 'Paparan Ibu Jari',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Warna',
    Card: 'Kad',
    Basic: 'Asas',
    Statistics: 'Statistik',
    Analytics: 'Analitik',
    CardActions: 'Tindakan Kad',
    CardColors: 'Warna Kad',
    Table: 'Jadual',
    agGridTable: 'Jadual agGrid',
    Components: 'Komponen',
    Alert: 'Amaran',
    Avatar: 'Avatar',
    Badge: 'Lencana',
    Breadcrumb: 'Jejak Roti',
    Button: 'Butang',
    ButtonGroup: 'Kumpulan Butang',
    Chip: 'Cip',
    Collapse: 'Runtuh',
    Dialogs: 'Dialog',
    Divider: 'Pembahagi',
    DropDown: 'Menu Lungsur',
    List: 'Senarai',
    Loading: 'Memuatkan',
    Navbar: 'Bar Navigasi',
    Notifications: 'Pemberitahuan',
    Pagination: 'Penomboran',
    Popup: 'Popup',
    Progress: 'Kemajuan',
    Sidebar: 'Bar Sisi',
    Slider: 'Peluncur',
    Tabs: 'Tab',
    Tooltip: 'Petua Alat',
    Upload: 'Muat Naik',
    FormsAndTable: 'Borang & Jadual',
    FormElements: 'Elemen Borang',
    Select: 'Pilih',
    Switch: 'Suis',
    Checkbox: 'Kotak Semak',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Input Nombor',
    Textarea: 'Kawasan Teks',
    FormLayouts: 'Susun Atur Borang',
    FormWizard: 'Wizard Borang',
    FormValidation: 'Pengesahan Borang',
    FormInputGroup: 'Kumpulan Input Borang',
    Pages: 'Halaman',
    Authentication: 'Pengesahan',
    Login: 'Log Masuk',
    Register: 'Daftar',
    ForgotPassword: 'Lupa Kata Laluan',
    ResetPassword: 'Set Semula Kata Laluan',
    LockScreen: 'Skrin Kunci',
    Miscellaneous: 'Pelbagai',
    ComingSoon: 'Akan Datang',
    Error: 'Ralat',
    404: '404',
    500: '500',
    NotAuthorized: 'Tidak Dibenarkan',
    Maintenance: 'Penyelenggaraan',
    Profile: 'Profil',
    User: 'Pengguna',
    View: 'Lihat',
    Edit: 'Edit',
    UserSettings: 'Tetapan Pengguna',
    Invoice: 'Invois',
    FAQ: 'Soalan Lazim',
    Search: 'Cari',
    KnowledgeBase: 'Pangkalan Pengetahuan',
    ChartsAndMaps: 'Carta & Peta',
    Charts: 'Carta',
    ApexCharts: 'Carta Apex',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Peta Google',
    Extensions: 'Sambungan',
    QuillEditor: 'Editor Quill',
    DragAndDrop: 'Seret & Lepas',
    Datepicker: 'Pemilih Tarikh',
    DatetimePicker: 'Pemilih Tarikh Masa',
    AccessControl: 'Kawalan Akses',
    I18n: 'I18n',
    Carousel: 'Karusel',
    Clipboard: 'Papan Klip',
    ContextMenu: 'Menu Konteks',
    StarRatings: 'Penilaian Bintang',
    Autocomplete: 'Autolengkap',
    Tree: 'Pokok',
    Import: 'Import',
    Export: 'Eksport',
    ExportSelected: 'Eksport Dipilih',
    Others: 'Lain-lain',
    MenuLevels: 'Tahap Menu',
    MenuLevel2p1: 'Tahap Menu 2.1',
    MenuLevel2p2: 'Tahap Menu 2.2',
    MenuLevel3p1: 'Tahap Menu 3.1',
    MenuLevel3p2: 'Tahap Menu 3.2',
    DisabledMenu: 'Menu Dinyahaktifkan',
    Support: 'Sokongan',
    Documentation: 'Dokumentasi',
    RaiseSupport: 'Naikkan Sokongan',
    demoTitle: 'Tajuk Kad',
    SystemData: 'Data Sistem',
    demoText: 'Kek bijan biji snek cupcake halia denmark saya suka halia. Pai epal pai jujubes chupa chups muffin halvah lollipop. Kek coklat kek oat tiramisu marzipan gula plum. Donat pai manis kek oat dragée kek buah gula-gula kapas titisan limau.',
    'Forgot Password?': 'Lupa Kata Laluan?',
    'Welcome Back': 'Selamat kembali, sila log masuk ke akaun anda.',
    Password: 'Kata Laluan',
    'Remember Me': 'Ingat Saya',
    ResetPasswordDesc: 'Sila masukkan kata laluan baharu anda.',
    'Go Back To Login': 'Kembali Ke Log Masuk',
    Reset: 'Set Semula',
    RecoverPassword: 'Pulihkan kata laluan anda',
    SamePassword: '"Kata Laluan" mesti sama dengan "Sahkan Kata Laluan"',
    RecoverPasswordDesc: 'Sila masukkan alamat e-mel anda dan kami akan menghantar arahan untuk set semula kata laluan.',
    'Back To Login': 'Kembali Ke Log Masuk',
    'Recover Password': 'Pulihkan Kata Laluan',
    ForgotPasswordMessage: 'Terima kasih, sila semak e-mel anda untuk arahan set semula kata laluan.',
    'Add New': 'Tambah Baharu',
    'System Data': 'Data Sistem',
    Continue: 'Teruskan',
  },
}
